var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _g2, _g3, _path12, _g4, _path13, _path14, _g5, _g6, _path15, _g7, _path16, _path17, _path18, _path19, _path20, _g8, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g9, _path28, _path29, _path30, _path31, _g10, _path32, _path33, _path34, _path35, _g11, _path36, _path37, _g12, _path38, _g13, _path39, _path40, _path41, _path42, _g14, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g15, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g16, _path59, _path60, _path61, _path62, _path63, _g17, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g18, _path75, _path76, _path77, _path78, _path79, _path80, _g19, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _g20, _g21, _path90, _path91, _g22, _g23, _g24, _path92, _g25, _g26, _path93, _path94, _path95, _g27, _path96;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutpic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 730,
    height: 484.813,
    viewBox: "0 0 730 484.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5.736,
    y1: 0.045,
    x2: 6.234,
    y2: 0.92,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#ffcf40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#dc9a11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.413,
    y1: 0.23,
    x2: 0.604,
    y2: 0.746,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#c18c68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#f4c698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#f4c698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#e2b489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#d6a880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3a57d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.364,
    y1: 0.261,
    x2: 0.666,
    y2: 0.725,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#f4c698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#e2b489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#d6a880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#d3a57d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.364,
    y1: 0.102,
    x2: 0.663,
    y2: 0.863,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.244,
    y1: 0.185,
    x2: 0.812,
    y2: 0.796,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.381,
    y1: 0.198,
    x2: 0.722,
    y2: 0.743,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4c698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#f2c496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ebbd90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#dfb187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#d3a57d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.364,
    y1: 0.102,
    x2: 0.663,
    y2: 0.863,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.244,
    y1: 0.185,
    x2: 0.812,
    y2: 0.796,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.381,
    y1: 0.198,
    x2: 0.722,
    y2: 0.743,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M142.4,395.562c-12.525-7.55-22.936-1.963-23.253,12.482s9.583,32.271,22.108,39.827,22.941,1.963,23.258-12.481S154.933,403.112,142.4,395.562Z",
    transform: "translate(-119.143 -392.198)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M87.808,364.044c-12.525-7.556-22.936-1.963-23.253,12.476s9.588,32.277,22.113,39.827,22.941,1.968,23.253-12.476S100.343,371.595,87.808,364.044Z",
    transform: "translate(-64.548 -360.678)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.379,
    y1: 0.531,
    x2: 0.953,
    y2: 0.154,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75ae8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88c399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.538,
    y1: 0.5,
    x2: 0.904,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7f9186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.51,
    cy: 0.827,
    r: 0.968,
    gradientTransform: "translate(0.242) scale(0.515 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9ffd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#cef9ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#bcf0ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    stopColor: "#b2ebc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#afeac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ed9b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.309,
    y1: -0.068,
    x2: 0.639,
    y2: 0.881,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5e8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#a6e8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#adebc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#b9f1c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#caf8cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#d9ffd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#d6fdd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#c4f4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#b8eec9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#b1ebc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#afeac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#b3ecc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcf1ca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.374,
    y1: 0.321,
    x2: 0.692,
    y2: 0.907,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#030301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#0c0c07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#1d1c11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#343320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#525132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#777549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#a3a064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#d5d082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffa9c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.873, -0.488, 0.488, 0.873, 6.771, -5.485)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cy: 0.5,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.873, -0.488, 0.488, 0.873, 5.879, -6.392)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.873, -0.488, 0.488, 0.873, 6.351, -5.24)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.873, -0.488, 0.488, 0.873, 5.854, -4.972)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.873, -0.488, 0.488, 0.873, 7.241, -5.796)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.873, -0.488, 0.488, 0.873, 7.748, -5.191)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.873, -0.488, 0.488, 0.873, 5.643, -5.998)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0.873, -0.488, 0.488, 0.873, 7.304, -5.22)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M172.163,385.134,147.4,412.6l-30.026-20.382,32.7-36.75,16.7,11.6,5.966-1.518Z",
    transform: "translate(-117.378 -355.473)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 9.839,
    y1: -35.234,
    x2: 9.887,
    y2: -36.975,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.163
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#050607"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#708fa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9bc6ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 8.503,
    y1: -32.069,
    x2: 8.544,
    y2: -33.655,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 11.156,
    y1: -37.891,
    x2: 11.211,
    y2: -39.762,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 12.6,
    y1: -40.409,
    x2: 12.663,
    y2: -42.403,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 5.071,
    y1: -76.768,
    x2: 5.1,
    y2: -81.175,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 5.048,
    y1: -48.072,
    x2: 5.078,
    y2: -50.842,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 5.091,
    y1: -133.07,
    x2: 5.12,
    y2: -140.688,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 5.105,
    y1: -353.497,
    x2: 5.135,
    y2: -373.685,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 10.032,
    y1: 0.045,
    x2: 10.53,
    y2: 0.92,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(-39.836 -321.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(40.297 492.094)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M172.071,430.708c8.19-.887,22.5-2.291,29.039-10.68,3.049-3.9,2.9-8.464-.2-12.326-2.463-3.07-10.3-7.561-14.116-8.5-15.4-3.77-26.485-5.625-42.333-5.007-10.841.419-40.4,5.27-54.562,10.255-10.271,3.619-21.091,5.926-26.006,16.907-4.264,9.54-1.425,23.269,7.588,29.513C93.971,466.453,134.766,434.735,172.071,430.708Z",
    transform: "translate(56.502 -173.403)",
    fill: "#3d3838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M649.211,564.426,140.819,353.041S58.735,396.207,55.04,410.3c-3.533,13.455,28.889,30.965,28.889,30.965L451.744,653.727c37.385,22.011,89.64,13.858,123.347-3.748C671.663,599.547,667.85,577.66,649.211,564.426Z",
    transform: "translate(25.083 -353.041)",
    fill: "#3d3838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M124.2,419.829,92.721,438a8.441,8.441,0,0,1-7.631,0L41.5,412.833c-2.1-1.215-2.1-3.189,0-4.4l31.475-18.171a8.408,8.408,0,0,1,7.631,0L124.2,415.419C126.3,416.64,126.3,418.608,124.2,419.829Z",
    transform: "translate(-39.922 -194.129)",
    fill: "#3d3838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M243.705,375.515,212.23,357.344a8.442,8.442,0,0,0-7.631,0l-43.586,25.162c-2.108,1.221-2.108,3.194,0,4.41l31.475,18.171a8.442,8.442,0,0,0,7.631,0l43.586-25.162C245.813,378.7,245.813,376.73,243.705,375.515Z",
    transform: "translate(483.252 -338.194)",
    fill: "#3d3838"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(39.836 321.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(398.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(243.094 151.204)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M171.121,368.737a28.5,28.5,0,0,1,4.533-7.136,20.877,20.877,0,0,1,5.13-4.313c3.254-1.877,6.211-2.054,8.341-.818l8.491,4.926L181,389.973l-8.486-4.926c-2.108-1.226-3.409-3.823-3.42-7.523A21.944,21.944,0,0,1,171.121,368.737Z",
    transform: "translate(-115.439 -321.869)",
    fill: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    style: {
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M159.317,401.937l1.5-4.41c6.044-17.719,18.617-34,32.368-41.935l6.362-3.673a8.83,8.83,0,0,1,2.64-1.038l7.5-1.457a12.935,12.935,0,0,0-3.915,1.533L199.4,354.63c-15.272,8.819-29.228,26.888-35.939,46.565l-1.5,4.426a8.239,8.239,0,0,0-.323,5.238l-2.431-7.238A2.63,2.63,0,0,1,159.317,401.937Z",
    transform: "translate(-159.117 -349.261)",
    fill: "#e8a91d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M160.146,405.753l1.5-4.426c.85-2.5,1.823-4.98,2.9-7.416a96.222,96.222,0,0,1,15.5-24.355,71.452,71.452,0,0,1,17.542-14.794l6.362-3.673c3.436-1.984,6.55-2.167,8.8-.861l27.195,15.8c-2.248-1.307-5.361-1.124-8.792.86l-6.367,3.673a71.449,71.449,0,0,0-17.542,14.794,96.309,96.309,0,0,0-15.5,24.355q-1.613,3.662-2.9,7.416l-1.5,4.431c-1.188,3.431-.559,6.12,1.113,7.093l-27.205-15.81C159.582,411.878,158.958,409.189,160.146,405.753Z",
    transform: "translate(-157.3 -349.394)",
    fill: "url(#linear-gradient)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M166.7,405.128l1.49-4.415c6.045-17.714,18.617-33.992,32.368-41.93l6.362-3.673c4.619-2.667,8.384-.527,8.4,4.781l.048,18.1a4.1,4.1,0,0,1-1.861,3.216l-45.14,26.065C166.978,408.069,166.069,406.919,166.7,405.128Z",
    transform: "translate(-126.816 -329.393)",
    fill: "#e8a91d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M165.2,408.7l1.5-4.431a92.721,92.721,0,0,1,3.829-9.454,96.426,96.426,0,0,1,12.713-20.134,73.3,73.3,0,0,1,19.4-16.977l6.367-3.673c5.5-3.173,10.18-1.737,11.8,3.055l2.441,7.227c-1.1-3.243-4.264-4.221-7.991-2.065l-6.362,3.673A65.86,65.86,0,0,0,191.43,381.2a86.93,86.93,0,0,0-11.449,18.139,82.139,82.139,0,0,0-3.452,8.508l-1.49,4.415c-.532,1.517.038,2.576,1.07,2.377l-7.5,1.463C165.37,416.735,163.569,413.422,165.2,408.7Z",
    transform: "translate(-135.157 -336.526)",
    fill: "#f0b325"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M175.962,353.143l27.2,15.8a96.308,96.308,0,0,0-15.5,24.355l-27.2-15.8A96.221,96.221,0,0,1,175.962,353.143Z",
    transform: "translate(-153.218 -332.981)",
    fill: "#e8a91d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M179.274,379.477a102.955,102.955,0,0,1,9.4-14.885l-17.381-10.1a91.993,91.993,0,0,0-9.47,14.832Z",
    transform: "translate(-147.265 -327.075)",
    fill: "#1c1c1c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(62.14 38.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M182.363,358.209c6.475-3.743,11.739-.742,11.761,6.69s-5.211,16.5-11.686,20.241-11.745.742-11.766-6.7S175.883,361.946,182.363,358.209Z",
    transform: "translate(-170.672 -356.597)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M171.011,375.488c.016,6.286,4.463,8.819,9.938,5.663s9.889-10.814,9.873-17.106c-.022-6.276-4.469-8.814-9.938-5.652S170.99,369.207,171.011,375.488Zm1.043-.6c-.016-5.614,3.936-12.471,8.83-15.294s8.878-.559,8.889,5.061-3.936,12.471-8.83,15.294S172.07,380.506,172.054,374.886Z",
    transform: "translate(-169.188 -354.695)",
    fill: "#e8a91d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(0 23.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(0 12.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M175.878,328.474c-3.415,5.867-7.953,15.52-11.793,22.376l-28.652,19.117a5.7,5.7,0,0,1-3.936.861c-1.99-.269-4.152-.307-5.9-1.2a47.371,47.371,0,0,1-4.813-2.5c-1.533-1.016-4,2.076.2,4.528,1.076.635,1.57,1.059,2.63,1.721,1.549.963-7.712,5.464-9.137,9.873-1.516,4.652.167,7.335,3.727,8.7,3.646,1.387,6.109-.549,11.777-4.383a36.034,36.034,0,0,0,6.308-5.593,9.475,9.475,0,0,1,3.119-2.329c8.728-3.866,33.024-15.331,34.428-17.4,2.232-.882,22.4-21.79,23.065-31.9C196.985,328.91,176.6,327.232,175.878,328.474Z",
    transform: "translate(-113.912 -328.04)",
    fill: "#fcbe9f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M154.591,327.775c11.707,7.367-14.423,32.5-14.423,32.5s-19.51-12.573-15.047-18.343C131.462,333.739,142.884,320.408,154.591,327.775Z",
    transform: "translate(-67.748 -325.631)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(38.354 112.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(0 116.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M122.039,379.379c1.452-2.409,6.991-4.436,12.369-6.577,5.458-2.178,13.138-5.421,13.471-6.2.274-.64.14-1.463.618-1.968a2,2,0,0,1,1.129-.484,18.642,18.642,0,0,1,11.411,1.56c1.63.8,3.528,4.092,3.528,4.092-.161,2.054.151,8.8-.3,9.62,0,0-8.153,3.307-8.561,3.463-.78.285-1.038-.683-1.7-.721-6.018,3.076-13.654,5.652-17.16,6.125-4.017.554-13.019,2.087-15.17-2.576A6.974,6.974,0,0,1,122.039,379.379Z",
    transform: "translate(-120.88 -363.853)",
    fill: "#191619"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(0 12.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M121.838,373.739c2.151,4.663,11.153,3.13,15.17,2.576,3.506-.479,27.775-10.218,27.775-10.218.231,2.506-.075,3.4-.349,3.91,0,0-8.153,3.313-8.561,3.463-.78.291-1.038-.683-1.7-.72-6.018,3.076-13.654,5.652-17.16,6.13-4.017.548-13.3,2.081-15.455-2.581a5.935,5.935,0,0,1-.237-4.195A8.64,8.64,0,0,0,121.838,373.739Z",
    transform: "translate(-121.044 -366.097)",
    fill: "#e58d2e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(91.225 131.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M155.356,403.232c-5.362,4.4-13.229,3.3-15.972.791-.995-.909-.828-2.011-1.21-3.673C137,395.235,142.444,387,143,377.8c.048-.737-.35-6.679-.043-6.862,4.34-2.522,15.359-6.631,18.306-2.9,1.086,1.377.731,6.5.791,8.158C162.406,386.738,162.965,396.994,155.356,403.232Z",
    transform: "translate(-138.008 -366.536)",
    fill: "#191619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M138.634,399.232c2.742,2.506,10.61,3.608,15.972-.79,7.6-6.238,7.05-16.493,6.69-27.044-.027-.871.054-2.7-.021-4.437.973,1.549.656,6.378.71,7.991.36,10.546.914,20.8-6.69,27.044-5.367,4.393-13.234,3.291-15.977.785a5.124,5.124,0,0,1-1.253-4.292A4.951,4.951,0,0,0,138.634,399.232Z",
    transform: "translate(-137.897 -364.677)",
    fill: "#e58d2e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M171.577,366.055c1.215,12.858,2.732,25.511,3.533,36.089a37.613,37.613,0,0,0,.807,6.206,47.316,47.316,0,0,0,2.156,6.088c6.174,15.622,11.115,44.4,13.638,60.9.882,5.792-18.408,9.045-20.161,2.269-.575-2.2-9.319-39.671-13.923-49.711-2.425-5.3-6.023-10.019-8.308-15.38a79.679,79.679,0,0,1-3.576-11.922,273.622,273.622,0,0,0-11.159-34.422c-1.474-3.689-3.055-7.448-3.28-11.417l35.154-12.4C168.324,346.792,171.072,357.822,171.577,366.055Z",
    transform: "translate(-76.131 -341.011)",
    fill: "#084e9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M160.742,400.011c-.387,2.393-.651,11.191-2.775,20.79-3.958,17.891-10.761,40.666-11.4,44.618-.9,5.6-21.887,2.146-20.79-4.039,0,0,7.47-63.978,7.55-64.962.188-2.388.376-4.781.387-7.179.005-3.157.247-7.233.457-10.384.887-13.487,1.447-25.813,2.721-36.746,9.889.441,29.894,17.235,30.448,23.393.253,2.861-1.059,5.485-1.619,8.26C163.936,382.636,162.2,391.079,160.742,400.011Z",
    transform: "translate(-100.487 -342.11)",
    fill: "#084e9b"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M163.9,330.132c6.109,1.872,12.449,3.393,18.327,5.862,6.012,2.522,10.766,7.653,11.928,14.068,1.215,6.7.344,16.154-4.383,29.249a74.2,74.2,0,0,0-3.426,17.133,46.935,46.935,0,0,0,.661,12.487,41.855,41.855,0,0,0,2.608,9.11c5.786,12.094-18.7,17.509-31.25,15.74-11.632-1.635-24.307-4.942-23.947-16.719.382-12.541,1.312-25.275-1.565-37.488-1.533-6.518-4.135-12.772-5.292-19.365a90.3,90.3,0,0,1-1.027-11.928l-.366-8.819a13.723,13.723,0,0,1,12.906-14.2C147.374,324.809,156.091,327.729,163.9,330.132Z",
    transform: "translate(-60.305 -304.022)",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(113.678 117.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M227.116,483.126a47.491,47.491,0,0,1-47.205-46.07c-.118-4.539-.059-8.486-.016-11.433l.021-1.785c.118-9.723,1.9-19.338,3.63-28.642.511-2.732,1.016-5.458,1.479-8.185,1.3-7.6.549-19.489-5.84-27.98-4.77-6.34-12.073-10.1-21.7-11.191a38.776,38.776,0,0,0-19.354,3.055,2.213,2.213,0,0,1-1.726-4.076,43.325,43.325,0,0,1,21.575-3.377c10.89,1.231,19.214,5.577,24.748,12.928,9.325,12.4,7.19,28.319,6.668,31.384-.473,2.748-.979,5.5-1.49,8.249-1.694,9.12-3.442,18.547-3.555,27.888l-.027,1.8c-.043,2.893-.1,6.776.016,11.25A42.92,42.92,0,0,0,241.5,476.194c19.36-6.872,31.841-17.413,32.556-27.507l.21-3.178c.791-12.589,1.613-25.614,17.994-31.949a2.214,2.214,0,0,1,1.6,4.13c-13.74,5.313-14.4,15.875-15.17,28.1l-.21,3.216c-.866,12.051-14.132,23.78-35.492,31.362A47.309,47.309,0,0,1,227.116,483.126Z",
    transform: "translate(-135.051 -343.205)",
    fill: "#1c1c1c"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M133.128,353.6l-6.717,5.829.817,15.839,5.966-1.518Z",
    transform: "translate(-59.194 -179.774)",
    fill: "#101010"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M190.366,342.514c-4.765,1.032-9.158,2.415-13.815,3.861a65.011,65.011,0,0,0-7.932,2.57,2.846,2.846,0,0,0-1.457,1.119L125.77,408.837c-.764,1.129,4.442,4.614,5.125,3.705.07-.1,36.939-52.389,36.939-52.389,6.615-5.6,14.331-6.824,20.747-8.475C191.8,350.812,191.609,342.245,190.366,342.514Z",
    transform: "translate(-62.337 -228.334)",
    fill: "#1c1c1c"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(106.21 28.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M136.346,408.179a11.386,11.386,0,0,0,3.124-6.114,3.031,3.031,0,0,0-1-2.592c-.608-.511-1.42-.414-2.135-.769a4.271,4.271,0,0,1-2.377-4.3,1.2,1.2,0,0,1,.22-.592,1.011,1.011,0,0,1,1.086-.22c.7.231,1.022.763,1.581,1.151a3.754,3.754,0,0,0,2.183.484,12.511,12.511,0,0,0,5.894-1.484c16.612-16.4,21.521-25.275,21.521-25.275-7.642-8.916-21.435-23.533-20.58-28.276.312-1.764,3.608-4.356,5.464-5.222l13.353-4.248c.446,1.527,6.55,11.707,12.014,22.43,4.942,9.7,7.023,14.095,6.588,16.633a9.333,9.333,0,0,1-1.925,3.711,49.071,49.071,0,0,1-4.27,4.937c-4.652,4.856-9.712,9.314-14.692,13.826-2.28,2.065-4.566,4.13-6.781,6.26-.882.839-1.753,1.7-2.587,2.581a2.038,2.038,0,0,0-.817,1.6,5.3,5.3,0,0,1-.855,3.146,6.143,6.143,0,0,1-1.656,1.3,23.6,23.6,0,0,0-2.484,2.28,16.262,16.262,0,0,1-3.14,2.119,10.5,10.5,0,0,1-6.561,1.129,6.108,6.108,0,0,1-2.958-1.328,1.16,1.16,0,0,1-.436-.64c-.07-.473.366-.85.737-1.14A13.619,13.619,0,0,0,136.346,408.179Z",
    transform: "translate(-132.541 -308.692)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M169.362,352.479c3.081,5.872-22.613,18.849-25.786,11.944-1.065-2.328-12.256-25.893-9.47-33.691,0,0-.565-3.926-.312-3.958,6.529-.855,16.961,1.963,22.893,7.523C160.6,337.954,164.754,343.681,169.362,352.479Z",
    transform: "translate(-133.662 -326.623)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(60.362 0.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M151.053,350.1c-6.7,4.109-17.891-1.022-21.833-4.141-1.049-.833.834-1.42.543-2.726a5.659,5.659,0,0,1,.651-3.42,46.6,46.6,0,0,1,4.082-7.5,13.95,13.95,0,0,1,2.6-3.065,16.243,16.243,0,0,1,2.339-1.511,11.9,11.9,0,0,1,3.6-1.538,10.311,10.311,0,0,1,4.953.613,46.112,46.112,0,0,1,7.529,3.657C163.825,336.347,154.99,347.667,151.053,350.1Z",
    transform: "translate(-108.666 -301.056)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M137.707,353.678c-2.436.011-6-2.081-7.851-3.651-.694-.592,10.368-25.092,10.814-25.1a13.427,13.427,0,0,0,1.909,7.362c1.172,1.818,3.006,2.431,4.711,3.775C151.14,339.1,144.429,353.651,137.707,353.678Z",
    transform: "translate(-104.617 -306.153)",
    fill: "#f3a984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M131.274,359.642a7.21,7.21,0,0,1,1.952,1.371,4.994,4.994,0,0,1,.85,2.4c.215,1.242.425,2.479.634,3.722a2.313,2.313,0,0,0,.715,1.581c.629.462,1.506.177,2.237-.1s1.651-.484,2.216.065c.328.312,3.4,5.372,7.47,3.544,6.588-2.963,14.6-19,13.724-31.013-.3-4.109-1.49-8.706-4.119-12.008-6.211-7.8-12.7-7.545-15.783-7.507a13.865,13.865,0,0,0-9.906,4.813c-3.259,3.625-5.367,10.755-5.663,13.337-.629,5.533.14,12.342,3.409,17.725A6.4,6.4,0,0,0,131.274,359.642Z",
    transform: "translate(-123.986 -320.34)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M155.71,355.066c-2.28,2.678-4.738-1.317-5.335-2.28-1.135-1.818-2.323-1.414-3.775-.2-8.395,6.98-14.245,5.27-18.08,2.791-3.27-2.119-3.522-9.5-3.34-12.584.463-7.706,4.614-20.779,17.875-21.339,4-.167,9.674,1.269,13.165,3.979,3.13,2.431,5.716,7.663,6.362,11.578a26.351,26.351,0,0,1-.312,8.217c-1.081,2.119-2.076,2.2-3.028,4.076A35.355,35.355,0,0,1,155.71,355.066Z",
    transform: "translate(-125.137 -321.438)",
    fill: "#4f321f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M134.942,326.105a2.8,2.8,0,0,1,3.581,1.086c1.334,2.8-3.866,11.616-6.066,12.084C129.876,339.839,131.264,327.729,134.942,326.105Z",
    transform: "translate(-98.884 -302.075)",
    fill: "#fcbe9f"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M140.156,353.753,123.458,363l16.7,11.6,4.634-18.071Z",
    transform: "translate(-72.122 -179.107)",
    fill: "#1c1c1c"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(58.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M151.181,353.862c-4.91,2.216-21.441,1.974-25.458-4.281,0,0-5.007-18.187,11.417-26.146a19.715,19.715,0,0,1,10.551-2.07c13.062,1.361,15.17,14.971,15.17,14.971C163.615,339.078,157.511,351.006,151.181,353.862Z",
    transform: "translate(-123.637 -321.277)",
    fill: "#005fc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M126.009,342.032c3.646,2.549,8.142,3.356,14.175,2.71,9.034-.963,13.966-13.471,16.9-16.977-5.028,3.334-28.572,5.292-30.529-1.4C126.552,326.362,122.89,339.849,126.009,342.032Z",
    transform: "translate(-124.751 -299.015)",
    fill: "#2789e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M127.1,325.239c.258.963,1.635,1.431,3.071,1.054s2.382-1.479,2.119-2.436-1.64-1.425-3.071-1.049S126.826,324.281,127.1,325.239Z",
    transform: "translate(-114.689 -315.143)",
    fill: "#2789e1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(66.71 11.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(477.188 30.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    style: {
      isolation: "isolate"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M198.908,329.219c-1.054,1.237-24.925,29.357-30.561,35.976-.941,1.1-1.56,1.834-1.726,2.044a27.646,27.646,0,0,0-3.625,6.6,75.768,75.768,0,0,0-2.291,7.953c-7.077,25.678-17.09,76.422-17.854,79.159l-.086.538-.231,1.549c-4.571,33.024,1.957,61.7,6.249,75.862,1.119,3.807,3.243,6.5,5.754,7.534a4.972,4.972,0,0,0,.624.21l2.753.753c-.21-.059-.414-.124-.624-.2-2.511-1.033-4.635-3.732-5.754-7.534-4.286-14.17-4.173-77.261-4.173-77.261.764-2.737,18.5-84.176,19.5-86.693s33.745-44.495,34.8-45.737Z",
    transform: "translate(-140.976 -329.219)",
    fill: "#a6e8be"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M195.06,331.623l-2.753-.753,8.507,54.723c-10.691,16.327-35.138,44.532-58.9,70.071l2.759.753c27.512-10.551,52.255-36.337,60.574-66.844Z",
    transform: "translate(-136.854 -321.991)",
    fill: "#75ae8b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M199.417,329.358c-1.054,1.242-24.925,29.356-30.561,35.982-.941,1.1-1.56,1.834-1.726,2.043a27.547,27.547,0,0,0-3.625,6.6,75.737,75.737,0,0,0-2.285,7.954c-7.082,25.673-17.1,76.422-17.859,79.159l-.086.532-.231,1.549c-4.566,33.035,1.963,61.7,6.249,75.873,1.119,3.8,3.243,6.5,5.754,7.534,2.592,1.011,5.308.161,7.421-2.323l51-60.886c-1.075-36.81-.946-57.885-3.167-91.361ZM146.555,463.035c.522-2.006,6.028-38.81,17.7-80.9,1.3-4.8,1.979-7.658,4.549-10.75l28.136-33.148,8.475,54.7C196.029,407.474,175.481,433.63,146.555,463.035Z",
    transform: "translate(-138.733 -328.611)",
    fill: "#8dcaa0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M142.164,437.112c1.35,6.787,2.856,12.638,4.173,16.988,1.119,3.8,3.243,6.5,5.754,7.534,2.592,1.011,5.308.161,7.421-2.323l51-60.886c-.721-23.333-.753-32.1-1.232-49.662C197.037,381.443,154.688,423.953,142.164,437.112Z",
    transform: "translate(-135.777 -243.662)",
    fill: "#699f7e",
    opacity: 0.4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M151.954,367.625,162.8,353.444a7.4,7.4,0,0,0,1.414-3.635l.005-4.485c.027-1.016-.57-1.032-1.328-.043l-10.75,14.638a7.4,7.4,0,0,0-1.414,3.63l-.1,4.039C150.6,368.6,151.2,368.615,151.954,367.625Z",
    transform: "translate(-98.739 -262.105)",
    fill: "#649f78"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M142.431,455.8c.522-2.006,6.028-38.81,17.7-80.9,1.3-4.8,1.979-7.658,4.549-10.75l28.136-33.148,8.475,54.7C191.905,400.242,171.357,426.4,142.431,455.8Z",
    transform: "translate(-134.609 -321.379)",
    fill: "#fffcee",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(357.033 62.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M262.872,445.268l-13.6-10.54c-1.264-1.549-62.343-63.112-82.068-74.529l-43.333-24.99c-1.006,1.506-2,2.968-2.9,4.334-.748,1.124-1.56,2.21-2.334,3.318l55.32,28.728c18.053,15.584,53.69,50.276,61.665,60.827,0,0,19.532,24.753-1.258,84.677a15.473,15.473,0,0,1-9.427,9.405,16.028,16.028,0,0,1-5.5.973,15.69,15.69,0,0,1-2.173-.285c-.371,2.345-.758,4.684-1.129,7.093-.1.64-.2,1.28-.3,1.92a156.409,156.409,0,0,0,23.818,6.383c5.561.963,13.213,2.076,18.424-.909,5.991-3.436,8.405-10.761,10.1-16.9,2.253-8.174,2.963-16.757,3.323-25.205C272.272,481.228,270.853,462.03,262.872,445.268Z",
    transform: "translate(-118.633 -335.209)",
    fill: "#669b78"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(83.945 16.087)"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M444.1,516.316a15.636,15.636,0,0,1-8.5,7.523,16,16,0,0,1-13.509-1.178l-157.786-91.1a1.229,1.229,0,0,1-.613-.936c-5.06-41.854-29.577-61.945-29.824-62.144a1.26,1.26,0,0,1-.468-.979v-31.7c-2.538,1.366-5.087,2.7-7.615,4.076-35.745,19.408-71.162,39.418-106.053,60.321-16.128,9.669-32.368,19.182-49.232,27.523l2.85,13.3,3.963,16.294L97.582,477.8l11.341,36.342,4.324,10.024,177.758,99.852L455.492,526.48Z",
    transform: "translate(-56.228 -285.714)",
    fill: "#423d3c"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M126.524,338.51l-8.266,22.23,8.266,103.934,3.238-1.87Z",
    transform: "translate(152.812 -273.896)",
    fill: "#346db8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M176.572,339.333c-.366-.226-.715-.447-1.081-.672l-7.6-4.388L105.98,440.335l74.292,42.892Z",
    transform: "translate(99.064 -292.447)",
    fill: "#d3a57d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M168.2,334.315c-.366-.231-62.219,105.832-62.219,105.832L171.9,478.2Z",
    transform: "translate(99.064 -292.259)",
    fill: "#cc9a75"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M238.952,381.441l6.077-22.893-.054-.387c.054-.113.054-4.861.054-4.861a2.089,2.089,0,0,0,.8-1.7,32.924,32.924,0,0,1,4.888-5.394l6.9-14.38s-37.493-6.959-60.364-4.969-84.6,41.182-84.6,41.182L77.649,395l-9.8,6.787,14.912,69.689C105.478,463.369,207.342,395.449,238.952,381.441Z",
    transform: "translate(-67.851 -326.495)",
    fill: "#eab88c"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M231.114,328.476c-3.35-.355-7.023-.753-9.9,1-34.256,20.865-100.223,56.648-139.572,83.978l-9.067,90.774L256.04,398.305Z",
    transform: "translate(-47.167 -319.165)",
    fill: "#a75"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M92.339,326.96l31.174,12.976.075,4.781,11.938-3.334,19.182-8.76S136.769,325.412,92.339,326.96Z",
    transform: "translate(39.349 -325.409)",
    fill: "#a75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(45.932 10.851)"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube",
    "data-name": "Axonometric Cube",
    transform: "translate(11.159 97.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left",
    "data-name": "Cube face - left",
    d: "M129.781,414.633,78.467,385.009V359.8l51.314,29.629Z",
    transform: "translate(-78.467 -289.003)",
    fill: "#2d2b2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right",
    "data-name": "Cube face - right",
    d: "M210.64,377.352l-122.63,70.8v-25.2l122.63-70.8Z",
    transform: "translate(-36.696 -322.52)",
    fill: "#383534"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top",
    "data-name": "Cube face - top",
    d: "M129.781,447.062,78.467,417.433l122.63-70.8,51.314,29.624Z",
    transform: "translate(-78.467 -346.636)",
    fill: "#2b2b2b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    style: {
      isolation: "isolate"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M263.939,385.073a19.646,19.646,0,0,0-.984-3.286c-.091-.236-.188-.473-.29-.7a17.279,17.279,0,0,0-2.872-4.464c-2.49-2.839-5.9-5.071-9.911-7.383-2.463-1.425-5.157-2.877-8.007-4.523-7.351-4.248-30.529-16.466-37.853-20.279a1.977,1.977,0,0,0-1.9-.1l-124.53,72.12,59.837,47.662,124.536-72.12C263.724,390.977,264.633,388.557,263.939,385.073Z",
    transform: "translate(-71.136 -260.125)",
    fill: "url(#linear-gradient-2)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M140.118,398.479a19.54,19.54,0,0,0-.979-3.28c-2.2-5.652-6.921-9-13.078-12.557-2.463-1.425-5.152-2.872-8.007-4.523-7.351-4.243-30.529-16.461-37.853-20.268a1.718,1.718,0,0,0-2.737,1.56c-.468,9.771,4.071,14.665,10.223,18.22,5.044,2.909,15.52,7.523,20.817,10.583a173.982,173.982,0,0,1,22.333,15.557,12.741,12.741,0,0,0,1.581,1.1C137.284,407.675,141.392,404.868,140.118,398.479Z",
    transform: "translate(-71.85 -201.417)",
    fill: "#c18c68"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M218.322,395.048c-9.411-47.953-4-48.447-6.5-57.783a12.845,12.845,0,0,0-.661-1.866A13.159,13.159,0,0,0,209,332.006a11.526,11.526,0,0,0-2.9-2.414c-1.823-1.049-3.662-1.425-4.878-.715L76.685,401l18.574,89.092L219.8,417.968a1.029,1.029,0,0,0,.419-.925A105.282,105.282,0,0,0,218.322,395.048Z",
    transform: "translate(-75.111 -328.512)",
    fill: "url(#linear-gradient-3)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M95.073,408.461c-9.416-47.958-4-48.447-6.5-57.783A12.833,12.833,0,0,0,82.844,343c-3.017-1.742-6.061-1.619-6.3,2.156-.957,16.289,2.947,42.553,4.587,60.6.532,5.84,1.344,11.809,1.124,16.617a3.1,3.1,0,0,0,1.4,2.517l11.9,6.389c.78.446,1.4.064,1.409-.834A105.527,105.527,0,0,0,95.073,408.461Z",
    transform: "translate(-76.392 -269.805)",
    fill: "#c18c68"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(132.173 63.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(81.8)"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-2",
    "data-name": "Axonometric Cube",
    transform: "translate(11.161 103.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-2",
    "data-name": "Cube face - left",
    d: "M161.029,418.434,109.716,388.8V363.6l51.314,29.629Z",
    transform: "translate(-109.716 -331.583)",
    fill: "#2d2b2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-2",
    "data-name": "Cube face - right",
    d: "M174.709,388.36l-55.452,32.019V395.171l55.452-32.019Z",
    transform: "translate(-67.944 -333.528)",
    fill: "#383534"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-2",
    "data-name": "Cube face - top",
    d: "M161.029,419.287l-51.314-29.629,55.452-32.014,51.313,29.624Z",
    transform: "translate(-109.716 -357.644)",
    fill: "#2b2b2b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(0 6.393)",
    style: {
      isolation: "isolate"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M228.01,396.079a18.925,18.925,0,0,0-.979-3.28c-.091-.242-.188-.473-.29-.7a17.11,17.11,0,0,0-2.877-4.464c-2.49-2.839-5.894-5.077-9.911-7.389-2.463-1.425-5.152-2.877-8-4.523-7.351-4.243-30.529-16.461-37.859-20.274a1.938,1.938,0,0,0-1.893-.1l-57.358,33.331,59.842,47.662,57.358-33.331C227.8,401.984,228.7,399.564,228.01,396.079Z",
    transform: "translate(-102.384 -271.134)",
    fill: "url(#linear-gradient-4)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M171.362,402.277a19.054,19.054,0,0,0-.979-3.281c-2.194-5.646-6.921-9-13.073-12.557-2.463-1.425-5.157-2.872-8.007-4.523-7.351-4.243-30.529-16.461-37.859-20.274a1.719,1.719,0,0,0-2.732,1.565c-.473,9.777,4.066,14.665,10.223,18.22,5.039,2.909,15.515,7.523,20.812,10.583a174.707,174.707,0,0,1,22.339,15.552,11.561,11.561,0,0,0,1.581,1.1C168.528,411.472,172.637,408.665,171.362,402.277Z",
    transform: "translate(-103.095 -244.001)",
    fill: "#c18c68"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M182.393,406.059c-9.416-47.958-4-48.447-6.5-57.788a13.319,13.319,0,0,0-2.829-5.259,11.615,11.615,0,0,0-2.9-2.409c-1.823-1.059-3.657-1.425-4.878-.715l-57.353,33.331L126.5,462.3l57.358-33.331a1.015,1.015,0,0,0,.419-.93A104.781,104.781,0,0,0,182.393,406.059Z",
    transform: "translate(-106.355 -339.521)",
    fill: "url(#linear-gradient-5)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M126.321,412.254c-9.411-47.958-4-48.447-6.5-57.783a12.839,12.839,0,0,0-5.733-7.674c-3.011-1.737-6.055-1.613-6.3,2.156-.957,16.289,2.952,42.548,4.593,60.606.532,5.835,1.344,11.8,1.124,16.611a3.09,3.09,0,0,0,1.4,2.511l11.9,6.394c.78.452,1.4.064,1.4-.828A104.818,104.818,0,0,0,126.321,412.254Z",
    transform: "translate(-107.64 -312.385)",
    fill: "#c18c68"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(15.932 16.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M120.842,359.762l24.484-14.138s-4.35-4.221-8.905-4.178l-25.818,15c.941-.473,2.146-.92,4.759,1.275C118.928,360.714,120.842,359.762,120.842,359.762Z",
    transform: "translate(-110.603 -341.446)",
    fill: "#c18c68"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(16.792)",
    style: {
      isolation: "isolate"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M142.091,343.559a3.967,3.967,0,0,0-.344-1.495,5.132,5.132,0,0,0-.866-1.328,7.131,7.131,0,0,0-1.8-1.446c-1.651-.957-3.608-1.28-4.813-.581l-22.941,13.336,7.475,20.317,22.941-13.331a2.526,2.526,0,0,0,.936-2.576C142.2,351.276,142.161,346.264,142.091,343.559Z",
    transform: "translate(-108.276 -338.332)",
    fill: "url(#linear-gradient-6)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M121.637,346.038a5.458,5.458,0,0,0-3.006-4.27c-1.984-1.151-4.4-1.382-5.437-.038-1.957,2.485-2.576,8.292-2.4,12.073A5.673,5.673,0,0,0,113.3,358l5.69,3.281c1.952,1.129,3.463.027,3.232-2.345C121.745,353.76,121.707,348.743,121.637,346.038Z",
    transform: "translate(-110.763 -327.48)",
    fill: "#c18c68"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-3",
    "data-name": "Axonometric Cube",
    transform: "translate(53.464 125.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-3",
    "data-name": "Cube face - left",
    d: "M206.329,445.426,102.371,385.4l12.376-21.479L206.329,416.8Z",
    transform: "translate(-102.371 -351.606)",
    fill: "#c18c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-3",
    "data-name": "Cube face - top",
    d: "M196.255,426.833l-91.582-52.878,21.345-12.32L217.6,414.508Z",
    transform: "translate(-92.297 -361.635)",
    fill: "#f4c698"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M121.656,363.129,106.3,371.992c-1.393.807-1.387,2.119.005,2.92l33.954,19.607a5.6,5.6,0,0,0,5.05,0l15.359-8.868c1.393-.8,1.393-2.108,0-2.915l-33.96-19.607A5.583,5.583,0,0,0,121.656,363.129Zm38.289,20.021a1.1,1.1,0,0,1,0,2.081L144.587,394.1a4,4,0,0,1-3.6,0l-33.954-19.607a1.1,1.1,0,0,1-.005-2.081l15.359-8.863a3.976,3.976,0,0,1,3.6,0Z",
    transform: "translate(-36.255 -232.426)",
    fill: "#c18c68",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(0 47.23)"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Axonometric_Cube-4",
    "data-name": "Axonometric Cube",
    transform: "translate(11.159 103.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_left-4",
    "data-name": "Cube face - left",
    d: "M145.818,427.216,94.5,397.587V372.379l51.313,29.63Z",
    transform: "translate(-94.504 -340.365)",
    fill: "#2d2b2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_right-3",
    "data-name": "Cube face - right",
    d: "M159.5,397.138l-55.452,32.019V403.95L159.5,371.935Z",
    transform: "translate(-52.733 -342.306)",
    fill: "#383534"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cube_face_-_top-4",
    "data-name": "Cube face - top",
    d: "M145.818,428.069,94.5,398.439l55.452-32.014,51.314,29.629Z",
    transform: "translate(-94.504 -366.426)",
    fill: "#2b2b2b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(0 6.39)",
    style: {
      isolation: "isolate"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M212.8,404.861a20.055,20.055,0,0,0-.979-3.28c-.1-.242-.194-.473-.29-.7a17.255,17.255,0,0,0-2.877-4.463c-2.49-2.834-5.9-5.071-9.911-7.389-2.463-1.425-5.152-2.872-8.007-4.523-7.351-4.243-30.523-16.461-37.853-20.274a1.938,1.938,0,0,0-1.893-.1L93.63,397.456l59.837,47.662,57.358-33.331C212.584,410.766,213.492,408.346,212.8,404.861Z",
    transform: "translate(-87.173 -279.918)",
    fill: "url(#linear-gradient-7)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M156.155,411.062a19.456,19.456,0,0,0-.979-3.286c-2.194-5.646-6.921-9-13.078-12.557-2.463-1.425-5.152-2.872-8.007-4.523-7.351-4.243-30.524-16.456-37.853-20.268a1.719,1.719,0,0,0-2.737,1.56c-.468,9.776,4.071,14.665,10.228,18.219,5.039,2.909,15.515,7.529,20.817,10.583a173.837,173.837,0,0,1,22.328,15.558,13.154,13.154,0,0,0,1.581,1.1C153.321,420.253,157.429,417.445,156.155,411.062Z",
    transform: "translate(-87.887 -252.783)",
    fill: "#c18c68"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M167.186,414.84c-9.416-47.958-4-48.447-6.5-57.783a12.161,12.161,0,0,0-.656-1.866,13.446,13.446,0,0,0-2.167-3.4,11.735,11.735,0,0,0-2.9-2.409c-1.823-1.054-3.657-1.425-4.878-.715L92.722,382,111.3,471.09l57.358-33.331a1.017,1.017,0,0,0,.419-.925A105.194,105.194,0,0,0,167.186,414.84Z",
    transform: "translate(-91.148 -348.303)",
    fill: "url(#linear-gradient-8)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M111.11,421.036c-9.416-47.952-4-48.447-6.5-57.783a12.84,12.84,0,0,0-5.733-7.674c-3.011-1.737-6.061-1.613-6.3,2.156-.957,16.289,2.947,42.553,4.587,60.606.532,5.835,1.35,11.8,1.129,16.617a3.084,3.084,0,0,0,1.4,2.511l11.9,6.389c.78.452,1.409.065,1.409-.828A105.192,105.192,0,0,0,111.11,421.036Z",
    transform: "translate(-92.429 -321.168)",
    fill: "#c18c68"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(15.932 16.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M105.626,368.544l24.5-14.138s-4.356-4.221-8.916-4.178L95.392,365.237c.936-.484,2.146-.93,4.754,1.264C103.717,369.5,105.626,368.544,105.626,368.544Z",
    transform: "translate(-95.392 -350.228)",
    fill: "#c18c68"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(16.792)",
    style: {
      isolation: "isolate"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M126.884,352.338a3.949,3.949,0,0,0-.35-1.49,5.133,5.133,0,0,0-.86-1.334,7.224,7.224,0,0,0-1.8-1.447c-1.656-.957-3.614-1.274-4.818-.575L96.119,360.824l7.475,20.317,22.946-13.331a2.532,2.532,0,0,0,.936-2.576C126.992,360.06,126.954,355.043,126.884,352.338Z",
    transform: "translate(-93.069 -347.115)",
    fill: "url(#linear-gradient-9)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M106.426,354.816a5.441,5.441,0,0,0-3.006-4.264c-1.99-1.151-4.4-1.382-5.442-.038-1.957,2.49-2.57,8.292-2.4,12.067a5.648,5.648,0,0,0,2.511,4.2l5.69,3.28c1.947,1.129,3.463.027,3.232-2.345C106.534,362.538,106.5,357.521,106.426,354.816Z",
    transform: "translate(-95.552 -336.261)",
    fill: "#c18c68"
  }))))))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M120.868,407.087c-6.84,3.979-7.846,43.548-3.49,54.648l19.128-11.342a21.773,21.773,0,0,1,21.957-.14l71.055,40.881s-31.405-104.31-24.56-108.29Z",
    transform: "translate(221.42 -63.725)",
    fill: "#446950"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M120.868,407.087c-6.84,3.979-7.846,43.548-3.49,54.648l19.128-11.342a21.773,21.773,0,0,1,21.957-.14l71.055,40.881s-31.405-104.31-24.56-108.29Z",
    transform: "translate(221.42 -63.725)",
    fill: "#1d1c1b"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M65.672,359.371c-6.846,3.985-7.846,43.548-3.49,54.648L81.31,402.677a21.786,21.786,0,0,1,21.957-.14l71.055,40.886s-33.3-85.048-26.463-89.027Z",
    transform: "translate(-20.214 -188.26)",
    fill: "#1d1c1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(53.061 172.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(293.587 169.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    style: {
      isolation: "isolate"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M193.455,427.131a86.213,86.213,0,0,0-13.88-21.828,63.616,63.616,0,0,0-15.67-13.191c-9.975-5.759-19-6.286-25.528-2.5l-19.731,11.46,50.813,87.387L189.19,477c6.437-3.743,10.433-11.7,10.459-23.011C199.676,445.372,197.391,436.025,193.455,427.131Z",
    transform: "translate(-108.192 -387.192)",
    fill: "#1d1c1b"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M152.684,394.246c-19.811-11.438-35.917-2.259-35.982,20.473-.065,22.758,15.939,50.48,35.751,61.918s35.917,2.253,35.976-20.5C188.5,433.406,172.5,405.684,152.684,394.246Z",
    transform: "translate(-116.702 -377.861)",
    fill: "#2c2a29"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M144.4,395.277c-14.213-8.206-25.77-1.619-25.818,14.692-.043,16.332,11.433,36.218,25.651,44.425s25.77,1.619,25.818-14.713C170.1,423.37,158.617,403.483,144.4,395.277Z",
    transform: "translate(-108.454 -367.256)",
    fill: "#232221",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(11.721 25.094)",
    style: {
      isolation: "isolate"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M130.287,392.149l1.022-.054,6.507.731s1.414.2.43.457c-4.684,1.269-7.792,5.851-7.948,13.03-.269,12.2,8.093,27.259,18.671,33.637,6.421,3.872,12.186,3.657,15.778.161.721-.694-.446,1.683-.446,1.683l-2.13,3.791c-3.8,6.771-11.793,8.228-20.914,2.737-12.525-7.555-22.425-25.388-22.108-39.827C119.37,398.215,122.715,391.912,130.287,392.149Z",
    transform: "translate(-117.739 -390.824)",
    fill: "#c6c0b3"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M143.584,395.431c13.3,8.023,23.812,26.953,23.479,42.3s-11.39,21.269-24.694,13.25-23.818-26.958-23.479-42.3S130.279,387.413,143.584,395.431Zm-.038,1.619c-12.525-7.55-22.936-1.963-23.253,12.482s9.583,32.271,22.108,39.827,22.941,1.963,23.258-12.481-9.583-32.277-22.113-39.827Z",
    transform: "translate(-118.882 -391.859)",
    fill: "#e8dfd1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(13.125 26.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(7.349 -0.246)",
    style: {
      isolation: "isolate"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M141.858,395.333c11.347,7.018,20.188,23.377,19.747,36.541s-9.986,18.155-21.333,11.137-20.182-23.376-19.747-36.541S130.516,388.315,141.858,395.333Z",
    transform: "translate(-120.509 -392.153)",
    fill: "#a5a095"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M136.877,396.013c8.346,5.163,14.853,17.209,14.53,26.894s-7.357,13.358-15.7,8.19-14.858-17.2-14.536-26.888S128.531,390.851,136.877,396.013Z",
    transform: "translate(-117.647 -385.487)",
    fill: "#e8dfd1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M121.2,405.21l.011-.349c.323-9.7,6.62-14.025,14.616-10.766a20.545,20.545,0,0,1,3.028,1.559c5.34,3.3,10.008,9.11,12.976,15.509a33.333,33.333,0,0,1,3.356,14.713c-.366,10.884-8.26,15.009-17.644,9.206l-1.839-1.124c8.341,5.168,15.375,1.495,15.7-8.19a29.719,29.719,0,0,0-2.99-13.089c-2.635-5.695-6.792-10.863-11.54-13.8a18.581,18.581,0,0,0-2.694-1.382c-7.115-2.9-12.718.952-13.009,9.578l-.005.312Z",
    transform: "translate(-117.642 -388.349)",
    fill: "#c6c0b3"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    style: {
      isolation: "isolate"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M138.855,395.612a86.384,86.384,0,0,0-13.874-21.828A63.61,63.61,0,0,0,109.3,360.593c-9.97-5.754-19-6.292-25.522-2.5L64.052,369.557l50.813,87.387,19.725-11.465c6.442-3.737,10.433-11.7,10.465-23C145.082,413.853,142.792,404.512,138.855,395.612Z",
    transform: "translate(-53.598 -355.672)",
    fill: "#1d1c1b"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M98.09,362.726c-19.811-11.438-35.917-2.259-35.982,20.467-.065,22.764,15.934,50.485,35.745,61.924s35.917,2.253,35.982-20.505C133.9,401.88,117.9,374.164,98.09,362.726Z",
    transform: "translate(-62.108 -346.34)",
    fill: "#2c2a29"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M89.8,363.76c-14.213-8.212-25.77-1.624-25.813,14.686-.048,16.332,11.433,36.224,25.646,44.43s25.775,1.619,25.823-14.713C115.5,391.853,104.018,371.961,89.8,363.76Z",
    transform: "translate(-53.86 -335.737)",
    fill: "#232221",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(11.716 25.095)",
    style: {
      isolation: "isolate"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M75.7,360.633l1.016-.059,6.512.737s1.409.2.43.462c-4.684,1.258-7.8,5.851-7.954,13.025-.264,12.2,8.093,27.259,18.677,33.637,6.421,3.866,12.18,3.651,15.778.161.721-.694-.446,1.678-.446,1.678l-2.13,3.8c-3.8,6.765-11.8,8.228-20.914,2.732-12.525-7.55-22.425-25.383-22.113-39.827C64.781,366.7,68.12,360.4,75.7,360.633Z",
    transform: "translate(-63.144 -359.307)",
    fill: "#c6c0b3"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M88.988,363.912c13.3,8.018,23.818,26.958,23.484,42.29s-11.4,21.268-24.7,13.25-23.812-26.958-23.479-42.29S75.69,355.894,88.988,363.912Zm-.032,1.619c-12.53-7.556-22.941-1.963-23.258,12.476s9.588,32.277,22.113,39.827,22.941,1.968,23.253-12.476-9.578-32.277-22.107-39.827Z",
    transform: "translate(-64.287 -360.338)",
    fill: "#e8dfd1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(13.12 26.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(7.353 -0.244)",
    style: {
      isolation: "isolate"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M87.264,363.813c11.347,7.012,20.188,23.377,19.747,36.547s-9.992,18.15-21.333,11.132S65.49,388.109,65.931,374.945,75.923,356.8,87.264,363.813Z",
    transform: "translate(-65.915 -360.633)",
    fill: "#a5a095"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M82.278,364.5c8.346,5.163,14.853,17.2,14.53,26.888s-7.351,13.353-15.7,8.19-14.853-17.2-14.53-26.888S73.932,359.333,82.278,364.5Z",
    transform: "translate(-63.053 -353.964)",
    fill: "#e8dfd1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M66.608,373.7l.011-.355c.323-9.7,6.62-14.025,14.616-10.766a20.216,20.216,0,0,1,3.022,1.554c5.34,3.3,10.013,9.115,12.982,15.509a33.339,33.339,0,0,1,3.35,14.713c-.36,10.9-8.26,15.014-17.644,9.212l-1.839-1.124c8.346,5.163,15.375,1.5,15.7-8.19a29.673,29.673,0,0,0-2.985-13.095c-2.64-5.69-6.792-10.858-11.546-13.794a17.354,17.354,0,0,0-2.694-1.387c-7.109-2.9-12.718.952-13,9.578l-.005.312Z",
    transform: "translate(-63.048 -356.829)",
    fill: "#c6c0b3"
  })))))))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M78.563,369.741s-.791,22.554-2.382,27.813l210.255,121.6V489.146Z",
    transform: "translate(52.56 -121.09)",
    fill: "#7eb68f"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M171.8,421.8l-.215,2.581a1.8,1.8,0,0,1-.952,1.447,1.818,1.818,0,0,1-.834.2,1.843,1.843,0,0,1-.9-.242l-94.835-54.75a1.794,1.794,0,0,1-.473-2.721c6.421-7.491,15.477-14.019,26.178-18.87a64.975,64.975,0,0,1,26.544-5.969c.4,0,.791.091,1.188.1a63.331,63.331,0,0,0-23.877,5.706c-10.067,4.566-19.144,10.917-25.555,18.4Z",
    transform: "translate(39.358 -236.047)",
    fill: "#75ae8b"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(333.92 156.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M154.4,354.117c-12.928,4.42-25.307,17.472-27.587,29.082s6.389,17.461,19.316,13.041,25.307-17.477,27.587-29.088S167.324,349.692,154.4,354.117Zm-.263,3.673a23.368,23.368,0,0,1,2.28-.586l-5.9,18.117-14.568-3.936C140.516,365.378,147.233,360.151,154.132,357.79Zm16.617,11.218c-1.963,9.986-12.611,21.215-23.731,25.017s-18.58-1.231-16.617-11.218a26.685,26.685,0,0,1,3.931-9.029l17.967,4.861,7.152-21.957C167.485,355.946,172.373,360.732,170.749,369.008Z",
    transform: "translate(-61.325 -352.639)",
    fill: "#3a3835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M262.624,361.315l-12.245-6.179a4.926,4.926,0,0,0-3.909-.242c-48.3,17.7-98.115,49.4-132.134,80.423,3.92,5.636,5.926,12.374,7.168,19.36a9.782,9.782,0,0,1,5.77-.2c.323-.1,106.784-36.374,132.8-85.166C263.979,365.085,264.377,364.881,262.624,361.315Z",
    transform: "translate(-114.335 -344.054)",
    fill: "#ffd3ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M184.061,357.756c-3.947,16.966-29.1,29.308-57.616,29.174,0,0,8.072-16.746,22.538-25.458C169.665,349.007,184.061,357.756,184.061,357.756Z",
    transform: "translate(-61.322 -343.302)",
    fill: "#ffd3ab"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M193.837,557.588a16.742,16.742,0,0,1-4.926,2.925,17.206,17.206,0,0,1-14.53-1.264L93,512.266a1.2,1.2,0,0,1-.6-1.14l11-162.346a1.156,1.156,0,0,1,.661-.99,1.189,1.189,0,0,1,1.145.022c1.1.634,2.07,1.178,3.124,1.785L97.588,508.13a1.185,1.185,0,0,0,.6,1.135l81.385,46.984a17.084,17.084,0,0,0,14.267,1.339Z",
    transform: "translate(123.536 -217.78)",
    fill: "#4b7759"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M675.672,579.917a5.207,5.207,0,0,0-1.162-3.044c-1.124-1.328-2.447-2.14-2.474-2.49-.79-9.217-2.549-16.257-3.92-19.639-4.56-11.2-13.127-25.318-23.952-37.643A104.024,104.024,0,0,0,629.252,503l-52.335-40.558c-2.156.995-4.254,2.108-6.329,3.275,27.544,23.619,52.8,52.066,69.355,83.273C608.554,590.71,548.56,604.3,548.56,604.3c-49.415-14.9-95.292-41.714-132.166-73.8-2.28.554-4.248.968-5.749,1.189,0,0-3.114,4.291-13.993-10.352-6.507-8.755-16.38-27.006-28.378-49.383-6.668-12.455-14.288-24.232-22.946-42.768-9.212-19.714-107.058-85.349-124.815-71.151-1.742,1.387-4.614,2.915-6.835,2.9l-71.749-.317c-.721-.005-35.417-4.668-47.877-23.71a3.637,3.637,0,0,0-5.1-.8q-2.678,1.887-5.286,3.8c-4.022,2.947-8.475,8.454-8.905,14.9a1.324,1.324,0,0,1,1.258-.145c3.194,3.049,5.033,5.351,9.588,9.68a10.627,10.627,0,0,1,2.834,8.626c-1.452,7.679-3.291,18.117-6.485,21.027-3.054,2.775-7.5.156-12.062-2.909-.188,3.727-.14,6.222-.14,6.222s-14.627,3.415-16.047,5.335c-3.157,4.264-.6,52.072,1.818,56.912,9.5,18.988,38.692,37.536,38.692,37.536,1.543-23.511,10.825-66.226,49.8-43.521q.653.371,1.307.774c20.57,12.691,36.875,41.231,38.042,65.607l207.9,120.223c1.145-24.194,18.66-33.573,39.735-21.4.441.253.882.516,1.328.8,20.532,12.637,43.93,45.769,44.339,98.454,36.756,15.111,82.1,4.114,120.884-14.907,40.359-19.79,70.178-44.624,77.2-64.327a19.032,19.032,0,0,0,.936-6.27C675.758,622.583,675.957,584.149,675.672,579.917ZM261.394,459.5l-94.835-54.755c6.41-7.481,15.488-13.832,25.56-18.4,13.466-6.1,28.862-7.894,42.8-2.947a50.215,50.215,0,0,1,8.594,3.969l22.737,13.347ZM374.836,603.912a16.975,16.975,0,0,1-10.148,10.132,17.206,17.206,0,0,1-14.53-1.264L268.772,565.8a1.2,1.2,0,0,1-.6-1.14l11-162.346a1.156,1.156,0,0,1,.661-.99,1.189,1.189,0,0,1,1.145.022c45.624,26.173,50.114,27.313,55.782,34.6,4.447,5.523,39.848,77.729,40.241,84.961C388.71,555.7,380.676,587.838,374.836,603.912Z",
    transform: "translate(-52.241 -271.31)",
    fill: "url(#linear-gradient-10)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M184.154,365.909l-24.339-13.95a64.282,64.282,0,0,0-17.44-7.367,62.055,62.055,0,0,0-37.493,2.113,109.934,109.934,0,0,0-16.811,8.572c-5.474,3.506-10.7,7.1-14.547,12.541a5.01,5.01,0,0,0-.973,2.146V424.95a1.86,1.86,0,0,0,.694,1.436c.242.194,24.581,20.215,29.609,61.752a1.784,1.784,0,0,0,.9,1.371l68.812,39.73a.534.534,0,0,0,.29.075.5.5,0,0,0,.269-.07.548.548,0,0,0,.312-.473l11-162.314A.584.584,0,0,0,184.154,365.909ZM172.34,527.754,104.334,488.5a.649.649,0,0,1-.323-.495c-5.077-42.042-29.787-62.327-30.04-62.531a.682.682,0,0,1-.247-.521V369.963a3.737,3.737,0,0,1,.613-1.253c3.872-5.491,9-9.013,14.348-12.444A109.924,109.924,0,0,1,105.3,347.8a60.786,60.786,0,0,1,36.783-2.07,63.3,63.3,0,0,1,17.139,7.238l24.038,13.778Z",
    transform: "translate(36.674 -239.712)",
    fill: "#649f78"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M378.578,551.787c14.326,8.185,28.077,15.88,39.752,22.14a27.117,27.117,0,0,0-3.969-.42,20.031,20.031,0,0,0-18.408,9.8,26.757,26.757,0,0,0-1.844,3.582c-.054.124-.108.247-.161.36-.274.667-.522,1.355-.753,2.06-.188.565-.366,1.135-.527,1.726-.14.495-.263,1-.376,1.522-.065.274-.107.575-.167.86a44.906,44.906,0,0,0-.86,6.733l-29.222-16.9L183.364,479.931c-.086-1.678-.237-3.3-.441-4.926-.07-.554-.177-1.119-.264-1.678-.167-1.108-.339-2.216-.565-3.329-.134-.656-.3-1.323-.441-1.985-.237-1.022-.473-2.044-.753-3.076-.188-.694-.393-1.387-.6-2.081-.3-.995-.608-2-.946-2.985-.237-.7-.479-1.4-.737-2.1-.36-.995-.742-1.979-1.145-2.968-.274-.683-.554-1.361-.844-2.044-.436-1.011-.9-2.011-1.377-3.011-.3-.634-.6-1.275-.909-1.909-.543-1.086-1.124-2.151-1.71-3.216-.285-.527-.559-1.059-.855-1.576-.9-1.57-1.834-3.125-2.818-4.635q-1.387-2.137-2.872-4.178c-1.318-1.812-2.71-3.539-4.141-5.222-.355-.425-.715-.839-1.081-1.248a76.17,76.17,0,0,0-9.271-8.932c-.409-.333-.817-.651-1.231-.973a60.243,60.243,0,0,0-5.028-3.522c-.29-.177-.559-.339-.834-.5-.161-.091-.328-.194-.489-.285-1.42-.833-2.786-1.549-4.13-2.2l-.29-.134a37.373,37.373,0,0,0-14.262-4.071,21.379,21.379,0,0,0-3.044.038c-.3.021-.586.075-.877.107-.6.07-1.188.151-1.764.264-.328.07-.645.156-.963.242-.511.129-1.016.264-1.511.43-.317.113-.635.231-.952.36-.468.183-.925.382-1.377.6-.3.14-.6.29-.887.452-.452.242-.887.511-1.312.785-.263.167-.527.334-.785.511-.462.328-.9.678-1.344,1.038-.2.167-.409.317-.6.484q-.9.8-1.737,1.678c-.656.688-1.221,1.355-1.764,2.044-.124.156-.237.317-.35.473-.414.543-.812,1.1-1.2,1.667-.151.226-.29.457-.436.683-.339.532-.672,1.07-.995,1.635-.14.248-.28.5-.414.748-.312.57-.613,1.145-.9,1.737-.124.242-.242.495-.36.742-.3.635-.592,1.275-.871,1.931-.091.21-.183.414-.269.629-.317.769-.618,1.543-.909,2.328-.038.1-.075.21-.113.312a85.9,85.9,0,0,0-3.442,12.783c-.516,2.678-.92,5.313-1.231,7.846-.323,2.608-.549,5.093-.7,7.384,0,0-.264-.167-.656-.425-.129-.081-.258-.172-.425-.285l-.554-.366c-.237-.156-.495-.333-.774-.527-.237-.156-.495-.339-.758-.516l-1.011-.7q-.428-.3-.887-.629c-.419-.3-.871-.618-1.323-.946-.312-.226-.618-.446-.946-.688-.527-.376-1.081-.791-1.64-1.215-.307-.231-.6-.446-.92-.688q-1.339-1.008-2.775-2.14c-1.011-.8-2.054-1.64-3.114-2.517-1.4-1.156-2.834-2.4-4.27-3.673-.36-.317-.715-.64-1.076-.968-1.473-1.328-2.942-2.7-4.383-4.13-1.2-1.2-2.382-2.441-3.528-3.7-.355-.387-.694-.791-1.043-1.183q-1.186-1.347-2.3-2.721c-.366-.457-.726-.919-1.086-1.382-.7-.914-1.366-1.845-2-2.78-.29-.425-.6-.85-.871-1.28a45.082,45.082,0,0,1-2.355-4.071,7.773,7.773,0,0,1-.409-1.253c-.048-.2-.1-.441-.151-.672-.081-.371-.161-.78-.242-1.237-.065-.355-.124-.71-.188-1.108-.065-.414-.124-.877-.194-1.339-.065-.49-.134-.957-.2-1.49-.247-2.017-.484-4.34-.7-6.873-.156-1.8-.285-3.533-.409-5.329-.134-2.049-.253-4.162-.36-6.292l-.065-1.355c-.1-2.151-.188-4.313-.253-6.437-.043-1.554-.075-3.087-.091-4.582l-.005-.269c-.021-1.576-.027-3.1-.016-4.56.021-2.855.1-5.378.242-7.523.016-.269.043-.5.065-.747.043-.57.091-1.081.151-1.581.048-.409.1-.828.151-1.194a16.536,16.536,0,0,1,.371-1.888,4.056,4.056,0,0,1,.462-1.14,2.189,2.189,0,0,1,.672-.559,9.765,9.765,0,0,1,1.221-.624c.64-.285,1.4-.57,2.232-.86,1.3-.446,2.452-.8,3.614-1.14.963-.285,1.925-.554,2.839-.8.6-.161,1.183-.317,1.726-.457.936-.242,1.769-.457,2.409-.613.844-.2,1.355-.323,1.355-.323s-.048-2.485.038-6.34c4.662,3.183,9.11,5.8,12.164,3.027,1.689-1.538,3-5.179,4.071-9.405,21.435,24.732,47.662,45.909,76.024,68.587,31.728,24.318,67.506,49.114,108.575,75.04l-2.452,36.428a1.2,1.2,0,0,0,.6,1.14l81.385,46.984a17.206,17.206,0,0,0,14.53,1.264,16.979,16.979,0,0,0,10.148-10.126C376.056,560.525,377.368,556.428,378.578,551.787ZM675.742,541.36c-70.114,70.125-135.28,113.877-235.627,43.882,1.183,1.011,2.35,2.092,3.506,3.216.473.457.947.952,1.414,1.436.661.672,1.318,1.35,1.968,2.06.624.678,1.237,1.377,1.85,2.092.446.522.882,1.049,1.323,1.587.747.909,1.49,1.834,2.226,2.8.108.145.215.3.323.446a109.17,109.17,0,0,1,13.331,23.667c.1.242.2.484.3.726a128.708,128.708,0,0,1,4.523,13.073c.269.941.522,1.9.774,2.855,1.022,3.867,1.931,7.868,2.662,12.073.215,1.253.393,2.554.57,3.845.715,4.84,1.237,9.863,1.517,15.127.134,2.544.253,5.109.269,7.76,2.635,1.081,5.319,1.99,8.029,2.818.85.258,1.715.468,2.576.7,1.914.511,3.84.984,5.781,1.382.973.2,1.947.387,2.925.559q2.944.5,5.932.839c.882.1,1.764.226,2.651.306,2.85.253,5.722.43,8.62.468q4.041.056,8.131-.167c.091-.005.183-.021.28-.021q3.985-.218,7.991-.661c4.367-.473,8.749-1.162,13.143-2.027,3.087-.608,6.157-1.269,9.223-2.038q3.9-.984,7.781-2.135,7.768-2.291,15.412-5.195c3.4-1.285,6.776-2.678,10.121-4.109l2.479-1.081c3.3-1.463,6.588-2.963,9.809-4.539q7.566-3.719,14.616-7.641c2.216-1.237,4.377-2.479,6.507-3.738.683-.4,1.344-.812,2.017-1.221,1.425-.855,2.845-1.716,4.221-2.587.78-.484,1.538-.973,2.3-1.463,1.242-.8,2.474-1.6,3.673-2.4.78-.522,1.543-1.043,2.307-1.559,1.156-.8,2.3-1.581,3.415-2.382.731-.516,1.463-1.038,2.173-1.56,1.119-.812,2.2-1.624,3.28-2.447.661-.495,1.328-.995,1.973-1.5,1.14-.892,2.248-1.785,3.34-2.683.516-.414,1.049-.839,1.549-1.253,1.57-1.323,3.092-2.635,4.544-3.947,3.081-2.775,5.888-5.55,8.394-8.292.973-1.059,1.861-2.108,2.743-3.167q1.1-1.331,2.129-2.657c.774-1.006,1.516-2.011,2.221-3.006.747-1.086,1.479-2.162,2.113-3.221a42.643,42.643,0,0,0,3.678-7.609,19.181,19.181,0,0,0,.941-6.27c0-.731.011-1.646.016-2.662,0-.21,0-.4.005-.581.005-.758.011-1.6.011-2.484l.011-1.178c0-.317,0-.608.005-.936v-.64c.011-1.226.011-2.527.016-3.877q.016-1.7.016-3.49c.011-1.474.016-3,.022-4.528,0-.478,0-.957.005-1.441.005-1.242.005-2.5.011-3.748v-.387c0-.333,0-.661.005-1q0-1.718.005-3.42v-1.678c.005-1.226.005-2.42.005-3.6C675.823,556.541,675.742,541.661,675.742,541.36Z",
    transform: "translate(-52.241 -231.279)",
    opacity: 0.2,
    fill: "url(#linear-gradient-11)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M108.2,398.765c-21.392-18.639-36.111-32.917-39.59-37.939l.038-15.057S52.8,356.8,52.514,357.378C73.218,376.206,108.2,398.765,108.2,398.765Z",
    transform: "translate(-51.046 -226.035)",
    fill: "#7fba97"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M234.592,389.261c-21.629,22.484-54.293,40.967-85.042,53.561a1.386,1.386,0,0,0-.866,1.291l-.048,17.913a1.391,1.391,0,0,0,1.646,1.4c13.224-2.8,74.835-37.692,85.892-53.465a4.952,4.952,0,0,0,.817-2.845v-16.9A1.384,1.384,0,0,0,234.592,389.261Z",
    transform: "translate(369.743 -37.574)",
    fill: "#649f78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(518.104 297.652)"
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M163.3,455.479c-5.733-17-8.265-24.925-14.713-38.192,16.794-5.179,50.969-25.711,62.284-38.434,4.178,14.09,7.437,23.049,12.766,37.638A191.707,191.707,0,0,1,163.3,455.479Z",
    transform: "translate(-148.585 -378.853)",
    fill: "#383534"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M215.87,409.272c.253.7.5,1.382.769,2.114a172.193,172.193,0,0,1-15.493,12.976,330.852,330.852,0,0,1-34.557,20.489c-1.554.694-3.1,1.414-4.646,2.06l-.307-.893-.737-2.178C172.338,438.225,196.317,425.512,215.87,409.272ZM205.852,379.9c-1.291,1.038-2.63,2.092-4.049,3.184-13.9,11.723-38.353,25.861-52.448,30.895.554,1.178,1.07,2.291,1.565,3.393,29.012-12.519,45.882-25.146,56.191-33.411Q206.489,381.991,205.852,379.9Zm-49.985,49.485q.653,1.766,1.317,3.619c30.126-13.761,44.979-25.689,55.013-33.9-.425-1.2-.839-2.382-1.248-3.56C199.941,404.545,184.82,416.311,155.866,429.384Zm-3.092-7.8c.538,1.269,1.049,2.511,1.543,3.77,29.529-13.154,45.237-25.377,55.347-33.567-.419-1.248-.839-2.511-1.264-3.8C196.145,397.893,180.318,409.508,152.774,421.581Zm5.711,15.143c.387,1.124.8,2.318,1.2,3.528,13.057-6.383,36.439-19.177,54.97-34.3-.409-1.124-.812-2.243-1.2-3.329C200.5,413.343,187.444,423.393,158.485,436.725Z",
    transform: "translate(-145.219 -374.274)",
    fill: "#383534",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M323.844,387.271c-.022-.511-.043-1.033-.07-1.473a5.207,5.207,0,0,0-1.162-3.044c-1.124-1.323-2.447-2.135-2.474-2.484-.016-.172-.038-.328-.054-.5-65.242,95.238-187.459,93.958-187.459,94.211,0,.054,6.034,3.678,21.521,4.2C227.73,480.675,311.852,417.821,323.844,387.271Z",
    transform: "translate(299.657 -77.191)",
    fill: "url(#radial-gradient)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M150.282,447.93a1.39,1.39,0,0,1-1.635-1.393l-.011,3.248a1.391,1.391,0,0,0,1.646,1.4c13.224-2.8,74.835-37.692,85.892-53.465a4.952,4.952,0,0,0,.817-2.845v-3.264a4.981,4.981,0,0,1-.817,2.85C225.117,410.232,163.505,445.123,150.282,447.93Z",
    transform: "translate(369.743 -25.333)",
    fill: "#a4e4bd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M136.977,393.855a6.879,6.879,0,0,1-4.775,1.877l-60.568-.613a1.112,1.112,0,0,1-.989-1.63c6.442-12.266,83.676-61.036,118.389-66.4a16.942,16.942,0,0,1,2.56-.188c6.007-.016,31.389.1,49.786,3.162C215.147,335.545,169.609,363.181,136.977,393.855Z",
    transform: "translate(27.757 -308.647)",
    fill: "#af955a",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M626.927,582.087c-2.689-4.388-4.587-6.292-10.3-12.793a104.03,104.03,0,0,0-14.912-14.106l-89.35-69.243c-1.264-1.549-62.343-63.107-82.063-74.523l-102.8-59.283c-23.527-13.584-79.078-13.283-82.375-12.874-2.974.36-23.215-12.562-57.164-15.714a24.9,24.9,0,0,0-10.771,2.086C139.685,340.6,63.543,386.819,63.543,386.819c-.258.183-.532.366-.791.549q-1.533,1.081-3.033,2.151a2.943,2.943,0,0,0,.134,4.818c19.134,12.917,31.3,20.408,54.293,20.785,21.349.35,66.527-.07,84.789,3.678,16.665,3.409,109.564,55.358,119.717,69.705,9.029,12.766,39.058,68.226,56.944,101.707A140.45,140.45,0,0,0,421.684,641.3c9.411,6.227,19,12,27.168,16.612a65.793,65.793,0,0,0,32.481,8.378c79.573-.145,130.36-50.883,145.4-73.932A9.607,9.607,0,0,0,626.927,582.087ZM189.439,408.711a6.879,6.879,0,0,1-4.775,1.877l-60.568-.613a1.112,1.112,0,0,1-.989-1.63c6.442-12.266,83.676-61.036,118.389-66.4a16.942,16.942,0,0,1,2.56-.188c6.007-.016,31.389.1,49.786,3.162C267.609,350.4,222.071,378.037,189.439,408.711ZM493.212,510.3c-46.07,40.951-93.711,57.487-113.156,62.736-5.4,1.463-11.116-.242-13.794-5.157L323.606,489.64a1.02,1.02,0,0,1,.559-1.441c70.162-25.4,109.08-61.682,114.141-66.6a.886.886,0,0,1,1.2-.021c21.145,17.961,41.16,36.939,63.833,59.7C510.8,488.768,500.3,503.993,493.212,510.3Z",
    transform: "translate(-24.706 -323.503)",
    fill: "url(#linear-gradient-12)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M92.606,369.005l-16.837-9.717a3.464,3.464,0,0,1-1.667-2.63v-3.646c0-.92.748-1.237,1.667-.7l16.837,9.723a3.448,3.448,0,0,1,1.662,2.624v3.651C94.268,369.22,93.526,369.537,92.606,369.005Z",
    transform: "translate(43.459 -198.539)",
    fill: "#649f78"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M95.942,363.664,74.947,351.543c-.6-.344-1.086-.14-1.086.457v2.388a2.266,2.266,0,0,0,1.086,1.716l20.994,12.121c.6.344,1.086.14,1.086-.457v-2.393A2.251,2.251,0,0,0,95.942,363.664Z",
    transform: "translate(42.404 -201.486)",
    fill: "#e8dfd1"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(40.946 1.876)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M111.276,405.006c-.333-.075-32.008-7.464-51.421-20.978.366-.226.629-.382,1.1-.661,18.257,12.508,47.081,19.666,50.3,20.44,17.848-15.789,41.526-31.83,66.726-45.21,16.676-8.878,32.519-15.821,46.086-20.241-5.915-2.339-29.647-11.524-54.5-13.466.6-.242,1.264-.549,1.839-.78.274-.107.511-.167.78-.258,27.937,3.195,53.561,13.917,53.82,14.025a.589.589,0,0,1-.054,1.1c-13.783,4.356-30.083,11.438-47.135,20.478-25.415,13.5-49.162,29.6-67.016,45.425a.606.606,0,0,1-.387.145A.5.5,0,0,1,111.276,405.006Z",
    transform: "translate(-59.855 -323.852)",
    fill: "#649f78"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M277.527,430.638c-46.07,40.951-93.711,57.487-113.156,62.735-5.4,1.463-11.116-.242-13.794-5.157l-42.655-78.234a1.02,1.02,0,0,1,.559-1.441c70.162-25.4,109.08-61.682,114.141-66.6a.886.886,0,0,1,1.2-.021c21.145,17.961,41.161,36.939,63.833,59.7C295.112,409.111,284.615,424.335,277.527,430.638Z",
    transform: "translate(190.979 -243.846)",
    fill: "#fffcee",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M199.441,399.285c-21.581-21.656-40.773-39.859-60.8-57.052C138.066,367.078,128.7,462.8,127.951,470.4a299.387,299.387,0,0,0,61.364-42.1C196.4,422,206.9,406.775,199.441,399.285Z",
    transform: "translate(279.191 -241.51)",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M287.653,401.62c-22.672-22.758-42.688-41.736-63.833-59.7a.879.879,0,0,0-1.194.021c-5.066,4.915-43.984,41.2-114.146,66.6a1.02,1.02,0,0,0-.559,1.441l42.655,78.234c2.678,4.915,8.389,6.62,13.794,5.157,19.446-5.248,67.086-21.785,113.156-62.735C284.615,424.335,295.112,409.111,287.653,401.62Zm-12.777,24.5c-47.291,42.037-95.421,58.186-113.915,63.182a11.579,11.579,0,0,1-3.033.414,8.368,8.368,0,0,1-7.647-4.216l-40.547-75.793c66.258-24.4,105.251-58.46,113.716-66.344,19.5,16.655,37.359,33.212,61.585,57.541a6.289,6.289,0,0,1,1.748,4.915C286.578,412.714,279.694,421.84,274.876,426.121Z",
    transform: "translate(190.979 -243.846)",
    fill: "#4b4c45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(588.023 265.477)"
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M180.135,372.87c5.507,12.761-6.738,27.281-17.155,35.858-3.054,2.517-.446,14.692,1.7,18.171,3.807,6.179,19.736-12.4,23.715-23.732C192.085,392.682,181.05,372.774,180.135,372.87Z",
    transform: "translate(-161.587 -372.87)",
    fill: "#aecdd1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M162.978,408.729c-2.6,2.14-1.092,11.234.737,16.052,6.087-2.533,16.171-15.816,19.731-24.474,3.21-7.8,1.361-17.214-1.113-24.21-1.108-2.022-1.968-3.253-2.2-3.227C185.64,385.632,173.395,400.151,162.978,408.729Z",
    transform: "translate(-161.584 -372.87)",
    fill: "#8aa5aa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M167.018,403.828c-.339,3.087-1.769,6.045-3.334,7.244-.2-.263-.371-.64-.565-.925a37.034,37.034,0,0,1-1.511-7.437c.758-1.871,1.8-3.388,2.893-3.829C166.276,398.149,167.4,400.365,167.018,403.828Zm14.245-27.856c-1.656.624-3.3,3.834-3.651,7.174-.35,3.356.721,5.528,2.393,4.861s3.275-3.893,3.614-7.2S182.909,375.353,181.263,375.972Zm-9.545,23.57c1.726-.726,3.4-4.06,3.764-7.453.36-3.377-.726-5.566-2.431-4.888-1.726.672-3.431,4-3.8,7.421C168.873,398.063,169.981,400.263,171.718,399.542Z",
    transform: "translate(-161.494 -359.752)",
    fill: "#aecdd1",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M180.135,372.87c5.507,12.761-6.738,27.281-17.155,35.858-3.054,2.517-.446,14.692,1.7,18.171,3.807,6.179,19.736-12.4,23.715-23.732C192.085,392.682,181.05,372.774,180.135,372.87Z",
    transform: "translate(-161.587 -372.87)",
    fill: "#aecdd1",
    opacity: 0.9,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(436.526 345.753)"
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M194.577,388.031c-21.688,8.206-42.763,9.857-57.331,9.685.038.871,4.431,22.258,5.308,24.415,16.773-.662,41.349-4.759,57.084-13.213a6.2,6.2,0,0,0,2.947-6.3C201.9,396.932,199.772,386.069,194.577,388.031Z",
    transform: "translate(-116.645 -387.797)",
    fill: "#aecdd1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M210.528,405.426a5.847,5.847,0,0,0,2.963-6.114c-.4-3.232-1.28-8.088-2.9-11.422-34.342,12.767-67.005,9.217-74.437,8.163a2.094,2.094,0,0,0-2.334,1.253c-1.355,4.13.893,11.32,3.651,16.649C147.69,417.435,188.087,416.252,210.528,405.426Z",
    transform: "translate(-133.413 -387.392)",
    fill: "#8aa5aa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M185.007,394.392c-.091,3.506-2.511,6.636-5.4,7s-5.173-2.2-5.087-5.706,2.511-6.641,5.41-7S185.1,390.88,185.007,394.392Zm-22.527-1.065c-2.893.36-5.313,3.5-5.4,7s2.183,6.06,5.082,5.706,5.319-3.5,5.4-7S165.378,392.972,162.48,393.327Zm-18.268,2.2c-2.9.355-5.318,3.49-5.4,6.991s2.183,6.066,5.076,5.706,5.319-3.484,5.41-7S147.11,395.166,144.212,395.526Z",
    transform: "translate(-109.822 -384.053)",
    fill: "#aecdd1",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M193.487,388.031c-21.037,7.959-41.489,9.745-55.992,9.691a89.81,89.81,0,0,0,1.823,11.191c.925,3.775,4.426,13.111,4.426,13.111,16.66-.925,39.773-5.023,54.8-13.105a6.2,6.2,0,0,0,2.947-6.3C200.806,396.932,198.682,386.069,193.487,388.031Z",
    transform: "translate(-115.555 -387.797)",
    fill: "#aecdd1",
    opacity: 0.9,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M155.748,390.68a145.6,145.6,0,0,1-19.591-1.253,2.094,2.094,0,0,0-2.334,1.253c-2.027,6.168,3.969,19.279,7.733,22.586,1.909,1.678,9.82,2.3,20.161,1.71A202.285,202.285,0,0,1,155.748,390.68Z",
    transform: "translate(-133.415 -380.766)",
    fill: "#d16a0d"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(16.776 82.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M71.953,349.77c-4.555-4.329-7.48-7.964-10.675-11.013-7.281,3.221-6.12,16.612-5.329,31.26.113,2.151,8.228,6.781,14.638,5.668,1.861-4.544,3.135-11.659,4.2-17.289A10.627,10.627,0,0,0,71.953,349.77Z",
    transform: "translate(-55.361 -338.757)",
    fill: "#ad2525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M55.455,344.45c.075,2.361.3,4.78.376,7.141,4.555,3.065,9,5.684,12.057,2.909a12.028,12.028,0,0,0,2.619-4.6C66.732,351.538,56.219,346.224,55.455,344.45Z",
    transform: "translate(-54.947 -313.835)",
    fill: "#d16a0d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M168.337,422.778,73.5,368.023c6.4-7.48,15.482-13.831,25.549-18.4,13.471-6.1,28.867-7.894,42.8-2.947a50.618,50.618,0,0,1,8.593,3.969l22.737,13.347Z",
    transform: "translate(40.832 -234.561)",
    fill: "#af955a",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M116.171,369.132l14.713,2.156a8.68,8.68,0,0,0,5.448-.989c3.84-2.124,11.083-6.227,15.391-9.3a6.143,6.143,0,0,0,2.56-4.781l.425-9.782C141.182,355.962,138.827,357.505,116.171,369.132Z",
    transform: "translate(227.622 -223.102)",
    fill: "#4b4c45"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M364.789,438.8c-2.689-4.388-4.587-6.292-10.3-12.793A104.027,104.027,0,0,0,339.579,411.9l-71.824-55.664-149.343,99.2a139.387,139.387,0,0,0,41.134,42.575c9.411,6.227,19,12,27.168,16.611A65.8,65.8,0,0,0,219.2,523c79.568-.145,130.354-50.883,145.4-73.932A9.607,9.607,0,0,0,364.789,438.8Z",
    transform: "translate(237.433 -180.214)",
    opacity: 0.4,
    fill: "url(#linear-gradient-13)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M165.314,344.23,151.057,363a4.134,4.134,0,0,0-.731,2.124l.016,2.538c0,.64.333.721.737.183l14.256-18.762a4.155,4.155,0,0,0,.731-2.13l-.016-2.538C166.05,343.779,165.717,343.7,165.314,344.23Z",
    transform: "translate(377.141 -234.306)",
    fill: "#efe7da"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(36.319 2.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(200.245 85.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(41.017 41.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M128.462,371.838c-12.745-3.571-23.145-5.8-23.145-5.8s10.035,3.533,22.758,7.152c-3.571,12.74-5.8,23.14-5.8,23.14s3.533-10.029,7.152-22.758c12.74,3.571,23.14,5.8,23.14,5.8s-10.029-3.539-22.758-7.158c3.571-12.74,5.8-23.14,5.8-23.14S132.076,359.109,128.462,371.838Z",
    transform: "translate(-97.474 -341.316)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M162.837,363.746a31.492,31.492,0,1,1-42.865-12.1A31.494,31.494,0,0,1,162.837,363.746Z",
    transform: "translate(-103.859 -347.631)",
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M105.92,448.317a72.229,72.229,0,1,0,26.437-98.664A72.232,72.232,0,0,0,105.92,448.317Z",
    transform: "translate(-96.231 -339.964)",
    fill: "url(#radial-gradient-3)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(461.859 351.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M169.483,413.526c-12.745-3.571-23.145-5.8-23.145-5.8s10.035,3.533,22.758,7.152c-3.571,12.74-5.8,23.14-5.8,23.14s3.533-10.029,7.152-22.764c12.74,3.576,23.14,5.8,23.14,5.8s-10.029-3.533-22.758-7.152c3.571-12.74,5.8-23.14,5.8-23.14S173.1,400.8,169.483,413.526Z",
    transform: "translate(-138.495 -383.007)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M203.858,405.437a31.494,31.494,0,1,1-42.865-12.094A31.5,31.5,0,0,1,203.858,405.437Z",
    transform: "translate(-144.88 -389.325)",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(345.229 66.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M147.79,360.55c-12.74-3.571-23.14-5.8-23.14-5.8s10.029,3.533,22.758,7.152c-3.571,12.745-5.8,23.145-5.8,23.145s3.533-10.035,7.152-22.764c12.74,3.576,23.14,5.8,23.14,5.8s-10.029-3.533-22.758-7.152c3.571-12.74,5.8-23.146,5.8-23.146S151.409,347.827,147.79,360.55Z",
    transform: "translate(-116.807 -330.035)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M182.17,352.463a31.491,31.491,0,1,1-42.865-12.094A31.5,31.5,0,0,1,182.17,352.463Z",
    transform: "translate(-123.192 -336.35)",
    fill: "url(#radial-gradient-5)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(468.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M170.635,348.224c-12.745-3.571-23.145-5.8-23.145-5.8s10.035,3.533,22.764,7.152c-3.571,12.74-5.8,23.14-5.8,23.14s3.539-10.029,7.152-22.758c12.745,3.571,23.145,5.8,23.145,5.8s-10.035-3.539-22.764-7.152c3.571-12.745,5.8-23.145,5.8-23.145S174.249,335.5,170.635,348.224Z",
    transform: "translate(-139.651 -317.707)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M205.007,340.139a31.491,31.491,0,1,1-42.86-12.094A31.486,31.486,0,0,1,205.007,340.139Z",
    transform: "translate(-146.032 -324.023)",
    fill: "url(#radial-gradient-6)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(125.251 203.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M106.884,386.105c-12.74-3.571-23.14-5.8-23.14-5.8s10.029,3.538,22.758,7.158c-3.571,12.74-5.8,23.14-5.8,23.14s3.538-10.029,7.152-22.764c12.745,3.571,23.145,5.8,23.145,5.8s-10.029-3.533-22.764-7.152c3.571-12.74,5.8-23.14,5.8-23.14S110.5,373.376,106.884,386.105Z",
    transform: "translate(-75.901 -355.585)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M141.259,378.017A31.49,31.49,0,1,1,98.4,365.923,31.494,31.494,0,0,1,141.259,378.017Z",
    transform: "translate(-82.286 -361.904)",
    fill: "url(#radial-gradient-7)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(0 54.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M83.593,358.324c-12.74-3.571-23.14-5.8-23.14-5.8s10.029,3.539,22.758,7.152c-3.571,12.745-5.8,23.145-5.8,23.145s3.538-10.035,7.152-22.764c12.745,3.571,23.145,5.8,23.145,5.8s-10.035-3.539-22.764-7.152c3.571-12.745,5.8-23.146,5.8-23.146S87.212,345.595,83.593,358.324Z",
    transform: "translate(-52.61 -327.803)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M117.968,350.231a31.49,31.49,0,1,1-42.86-12.094A31.495,31.495,0,0,1,117.968,350.231Z",
    transform: "translate(-58.995 -334.118)",
    fill: "url(#radial-gradient-8)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(520.207 253.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M180.328,395.416c-12.74-3.571-23.14-5.8-23.14-5.8s10.029,3.533,22.758,7.152c-3.571,12.74-5.8,23.14-5.8,23.14s3.533-10.035,7.152-22.764c12.74,3.571,23.14,5.8,23.14,5.8s-10.029-3.533-22.758-7.152c3.571-12.74,5.8-23.145,5.8-23.145S183.947,382.687,180.328,395.416Z",
    transform: "translate(-149.346 -364.896)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M214.708,387.322a31.492,31.492,0,1,1-42.86-12.094A31.5,31.5,0,0,1,214.708,387.322Z",
    transform: "translate(-155.73 -371.21)",
    fill: "url(#radial-gradient-9)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(109.79 61.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M104.009,359.63c-12.74-3.571-23.14-5.8-23.14-5.8s10.029,3.533,22.758,7.152c-3.571,12.74-5.8,23.14-5.8,23.14s3.533-10.029,7.147-22.758c12.745,3.571,23.145,5.8,23.145,5.8s-10.029-3.538-22.764-7.158c3.576-12.74,5.8-23.14,5.8-23.14S107.628,346.9,104.009,359.63Z",
    transform: "translate(-73.026 -329.108)",
    fill: "#fff",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M138.384,351.538a31.49,31.49,0,1,1-42.86-12.1A31.489,31.489,0,0,1,138.384,351.538Z",
    transform: "translate(-79.411 -335.423)",
    fill: "url(#radial-gradient-10)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(416.996 183.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(3.784 -1.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M152.368,355.532,118.946,393.66l15.826,11.723,26-46.554A18.9,18.9,0,0,1,152.368,355.532Z",
    transform: "translate(-114.3 -354.139)",
    fill: "url(#linear-gradient-14)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M154.166,355.273l-36.084,36.078L143.26,410l23.769-50.023C162.2,360.409,157.936,358.1,154.166,355.273Z",
    transform: "translate(-118.082 -355.273)",
    fill: "url(#linear-gradient-15)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M151.3,355.716l-31.733,39.6,9.158,6.781,27.431-44.387A18.96,18.96,0,0,1,151.3,355.716Z",
    transform: "translate(-111.599 -353.334)",
    fill: "url(#linear-gradient-16)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M150.428,355.856l-30.335,40.956,3.452,2.554,28.717-42.747A19.342,19.342,0,0,1,150.428,355.856Z",
    transform: "translate(-109.279 -352.721)",
    fill: "url(#linear-gradient-17)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(0 116.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(312.452 122.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M98,376.543c.473,2.3.855,4.636,1.162,7L183.514,392l.441-25.006Z",
    transform: "translate(-97.671 -359.555)",
    fill: "url(#linear-gradient-18)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M97.938,381.01a97.929,97.929,0,0,1,1.715,10.347l84,14.03.7-39.779Z",
    transform: "translate(-97.938 -365.609)",
    fill: "url(#linear-gradient-19)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M98.056,373.665q.371,2.009.661,4.06l84.639,4.716.258-14.466Z",
    transform: "translate(-97.421 -355.247)",
    fill: "url(#linear-gradient-20)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M98.094,371.246c.086.505.172,1.016.253,1.527l84.924,1.5.1-5.458Z",
    transform: "translate(-97.255 -351.574)",
    fill: "url(#linear-gradient-21)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(0 211.628)"
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M67.522,401.622a28.326,28.326,0,0,0-4.539-7.136,20.985,20.985,0,0,0-5.125-4.318c-3.264-1.877-6.217-2.054-8.346-.812l-8.491,4.921,16.617,28.577,8.491-4.926c2.1-1.221,3.409-3.829,3.415-7.523A22,22,0,0,0,67.522,401.622Z",
    transform: "translate(-34.648 -354.753)",
    fill: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    style: {
      isolation: "isolate"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M97.257,434.813l-1.495-4.41c-6.044-17.719-18.617-33.992-32.363-41.935L57.038,384.8a8.419,8.419,0,0,0-2.651-1.038L46.9,382.306a12.672,12.672,0,0,1,3.91,1.527l6.362,3.673c15.273,8.819,29.228,26.888,35.944,46.571l1.495,4.42a8.24,8.24,0,0,1,.323,5.238L97.37,436.5A2.672,2.672,0,0,0,97.257,434.813Z",
    transform: "translate(-8.908 -382.142)",
    fill: "#e8a91d"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M120.733,438.631l-1.495-4.42c-.855-2.506-1.828-4.985-2.9-7.416a96.374,96.374,0,0,0-15.5-24.366A71.537,71.537,0,0,0,83.294,387.64l-6.362-3.673c-3.436-1.979-6.55-2.162-8.8-.86l-27.2,15.8c2.248-1.3,5.362-1.118,8.8.86l6.362,3.679a71.316,71.316,0,0,1,17.547,14.788A96.178,96.178,0,0,1,89.134,442.6c1.076,2.431,2.049,4.91,2.9,7.416l1.5,4.42c1.188,3.436.565,6.125-1.108,7.1l27.2-15.81C121.3,444.756,121.921,442.067,120.733,438.631Z",
    transform: "translate(-35.029 -382.275)",
    fill: "url(#linear-gradient-22)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M88.509,438l-1.495-4.4c-6.044-17.719-18.612-34-32.368-41.935L48.284,388c-4.619-2.678-8.384-.527-8.395,4.781l-.054,18.09a4.108,4.108,0,0,0,1.861,3.221l45.145,26.065C88.224,440.955,89.133,439.794,88.509,438Z",
    transform: "translate(-39.836 -362.277)",
    fill: "#e8a91d"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M97.963,441.57l-1.5-4.42a91.225,91.225,0,0,0-3.829-9.454,96.471,96.471,0,0,0-12.713-20.14,73.189,73.189,0,0,0-19.4-16.972l-6.362-3.679c-5.507-3.173-10.185-1.731-11.8,3.06l-2.441,7.222c1.092-3.237,4.264-4.216,7.986-2.06L54.27,398.8a66,66,0,0,1,17.472,15.289,86.966,86.966,0,0,1,11.449,18.133,83.408,83.408,0,0,1,3.447,8.513l1.495,4.4c.527,1.527-.043,2.587-1.07,2.388l7.5,1.457C97.8,449.615,99.6,446.3,97.963,441.57Z",
    transform: "translate(-39.459 -369.409)",
    fill: "#f0b325"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M74.211,386.023l-27.195,15.81a96.178,96.178,0,0,1,15.493,24.361l27.2-15.8A96.377,96.377,0,0,0,74.211,386.023Z",
    transform: "translate(-8.404 -365.87)",
    fill: "#e8a91d"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M58.008,412.353a102.455,102.455,0,0,0-9.406-14.88l17.381-10.1a90.815,90.815,0,0,1,9.47,14.832Z",
    transform: "translate(-1.461 -359.956)",
    fill: "#1c1c1c"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348",
    transform: "translate(2.958 38.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M52.152,391.085c-6.48-3.738-11.745-.732-11.766,6.7-.022,7.443,5.211,16.509,11.691,20.247s11.739.737,11.761-6.706S58.627,394.828,52.152,391.085Z",
    transform: "translate(-40.386 -389.478)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M50.663,391.271c-5.474-3.157-9.927-.619-9.938,5.657s4.4,13.939,9.868,17.1,9.922.624,9.943-5.663S56.132,394.433,50.663,391.271ZM50.6,412.83c-4.894-2.829-8.846-9.674-8.83-15.3s4-7.884,8.889-5.055,8.846,9.674,8.83,15.283C59.472,413.384,55.492,415.653,50.6,412.83Z",
    transform: "translate(-38.902 -387.572)",
    fill: "#e8a91d"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350",
    transform: "translate(72.733 282.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M107.482,459.712c-13.691,0-27.383-3.012-37.8-9.029-10.519-6.077-16.316-14.278-16.316-23.108s5.8-17.036,16.316-23.113c20.849-12.035,54.777-12.03,75.621,0,10.519,6.077,16.31,14.283,16.31,23.113s-5.792,17.031-16.31,23.108C134.87,456.7,121.179,459.712,107.482,459.712Zm0-59.918c-12.89,0-25.78,2.834-35.595,8.5-9.094,5.254-14.1,12.094-14.1,19.279s5.007,14.025,14.1,19.273c19.634,11.331,51.566,11.325,71.195,0,9.094-5.249,14.1-12.094,14.1-19.273s-5.007-14.025-14.1-19.279C133.267,402.628,120.377,399.794,107.482,399.794Z",
    transform: "translate(-53.361 -395.438)",
    fill: "#1c1c1c"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M95.435,373.862l.893-5.094,19.938,5.251-2.14,7.132Z",
    transform: "translate(203.559 -229.775)",
    fill: "#101010"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M102.407,430.424a8.581,8.581,0,0,0,.651,2.3c.134.3.242.576.371.871a11.784,11.784,0,0,1,5.281-.21,130.211,130.211,0,0,0,12.982,1.721s-5.657-7.034-2.882-7.018c1.4.011,2.8.043,4.195.086,5.442.178,4.9-3.157,2.845-3.108a50.765,50.765,0,0,1-6.044-.505c-2.968-.253-4.856-2.339-7.615-3.044a6.344,6.344,0,0,0-.85-.129c-3.533-8.69-16.8-37.552-16.8-37.552.452-8.787,1.909-20.629,2.173-28.222a1.526,1.526,0,0,0-2.866-.775c-5.4,9.976-16.913,31.82-15.326,33.981.1,2.791,16.273,28.13,22.237,36.993A11.075,11.075,0,0,1,102.407,430.424Z",
    transform: "translate(128.854 -294.268)",
    fill: "#fcbe9f"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(125.61 1.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(0 135.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(80.333 130.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M125.752,410.2c-1.624-2.694-7.824-4.963-13.847-7.362-6.1-2.442-14.692-6.066-15.068-6.937-.307-.715-.156-1.635-.694-2.2a2.189,2.189,0,0,0-1.258-.538,20.757,20.757,0,0,0-12.772,1.748c-1.828.887-3.953,4.577-3.953,4.577.183,2.3-.167,9.846.333,10.766,0,0,9.126,3.7,9.578,3.867.877.328,1.162-.758,1.909-.8,6.733,3.442,15.283,6.324,19.2,6.856,4.5.613,14.568,2.339,16.972-2.888A7.79,7.79,0,0,0,125.752,410.2Z",
    transform: "translate(-78.01 -392.823)",
    fill: "#191619"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(0 13.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M126.277,403.884c-2.4,5.222-12.471,3.5-16.972,2.882-3.92-.538-31.083-11.433-31.083-11.433-.258,2.8.086,3.813.393,4.372,0,0,9.126,3.711,9.578,3.872.877.328,1.162-.753,1.909-.8,6.733,3.436,15.283,6.319,19.2,6.857,4.5.613,14.891,2.334,17.294-2.888a6.653,6.653,0,0,0,.269-4.695A9.812,9.812,0,0,1,126.277,403.884Z",
    transform: "translate(-78.132 -395.334)",
    fill: "#e58d2e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(0.138 146.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M70.912,436.889c6,4.921,14.81,3.684,17.875.882,4.388-4.006-3.216-15.542-4.044-29.351-.048-.817.4-7.475.054-7.674-4.861-2.823-17.192-7.421-20.483-3.237-1.215,1.538-.823,7.265-.887,9.12C63.023,418.432,62.405,429.908,70.912,436.889Z",
    transform: "translate(-63.182 -395.826)",
    fill: "#191619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M89.546,432.412c-3.071,2.8-11.874,4.044-17.875-.882-8.513-6.98-7.889-18.456-7.491-30.26.038-.979-.054-3.022.027-4.969-1.086,1.732-.726,7.142-.791,8.943-.4,11.8-1.022,23.28,7.486,30.26,6,4.921,14.81,3.684,17.881.882a5.752,5.752,0,0,0,1.4-4.8A5.451,5.451,0,0,1,89.546,432.412Z",
    transform: "translate(-63.219 -393.748)",
    fill: "#e58d2e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M85.759,395.285c-1.361,14.391-3.06,28.55-3.953,40.386a43.5,43.5,0,0,1-.9,6.942,53.463,53.463,0,0,1-2.42,6.813c-6.91,17.483-12.439,49.689-15.256,68.151-.99,6.48,20.6,10.121,22.559,2.538.645-2.468,10.433-44.392,15.579-55.626,2.716-5.931,6.738-11.207,9.3-17.208a90.025,90.025,0,0,0,4.006-13.337,304.188,304.188,0,0,1,12.487-38.525c1.651-4.135,3.415-8.33,3.668-12.777L91.486,368.773C89.394,373.731,86.324,386.073,85.759,395.285Z",
    transform: "translate(-63.194 -367.262)",
    fill: "#084e9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M80.752,433.282c.436,2.678.731,12.524,3.108,23.264,4.426,20.026,12.041,45.506,12.75,49.932,1.011,6.27,24.5,2.4,23.264-4.517,0,0-8.357-71.6-8.443-72.695-.215-2.673-.43-5.351-.436-8.029-.011-3.538-.28-8.1-.511-11.626-.995-15.09-1.619-28.883-3.049-41.117-11.067.495-33.449,19.279-34.067,26.173-.285,3.205,1.183,6.141,1.807,9.244C77.176,413.836,79.123,423.29,80.752,433.282Z",
    transform: "translate(-18.812 -368.492)",
    fill: "#084e9b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M101.684,355.08c-6.835,2.108-13.933,3.8-20.5,6.566-6.733,2.823-12.046,8.561-13.353,15.74-1.355,7.5-.382,18.074,4.91,32.739A83.092,83.092,0,0,1,76.571,429.3a52.634,52.634,0,0,1-.742,13.971,46.972,46.972,0,0,1-2.92,10.2c-6.475,13.541,20.924,19.6,34.971,17.617,13.014-1.839,27.2-5.534,26.8-18.714-.43-14.036-1.468-28.286,1.748-41.951,1.721-7.292,4.63-14.294,5.926-21.672A101.493,101.493,0,0,0,143.5,375.4l.414-9.873a15.364,15.364,0,0,0-14.444-15.886C120.173,349.127,110.428,352.391,101.684,355.08Z",
    transform: "translate(-45.32 -315.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M82.744,349.592c-15.477,0,9.674,29.529,9.674,29.529l-.183,4.291s10.1-.624,9.852-5.329C101.474,366.5,98.226,349.592,82.744,349.592Z",
    transform: "translate(0.352 -315.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(44.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M100.652,349.741c-7.5,2.861-15.154,4.2-27.474,8.663a2.588,2.588,0,0,0-1.307,3.807c5.507,8.685,14.724,18.15,24.667,14.353a14.577,14.577,0,0,0,9.008-17.848C104.33,354.839,102.475,352.941,100.652,349.741Z",
    transform: "translate(-71.473 -314.843)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M83.413,348.152l-10.9,18.569s-.086,2.689,3.3,7.179c5.216,6.932,10.626,7.658,14.025,7.2a5.819,5.819,0,0,0,4.754-4.012L95.276,375Z",
    transform: "translate(-66.925 -321.799)",
    fill: "#f3a984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M85.8,345.082c-8.1,3.157-14.073,8.922-12.17,24.441,1.463,11.938,11.514,24.011,20.462,30.5,2.21,1.6,9.013,3.323,11.2-1.828,1.855-4.367,6.238-17.149,6.335-28.276.075-8.948-.258-16.611-7.082-22.113C99.867,344.033,94.285,341.785,85.8,345.082Z",
    transform: "translate(-63.568 -342.234)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M88.27,376.386c1.936-11.438,16.2-3.522,23.936-11.255,1.4-4.722-.651-12.089-7-17.364-4.625-3.834-10.938-6.265-19.419-2.963-8.1,3.151-14.477,9.54-12.186,25.737.172,1.194,2,10.54,4.178,10.54,1.382-.312.35-5.286.57-6.679.366-2.307,2.893-3.539,4.576-1.726a5.547,5.547,0,0,1,1.457,2.925c.161,1.022-.269,2.162.317,3.081C85.646,380.177,87.663,379.978,88.27,376.386Z",
    transform: "translate(-64.227 -343.251)",
    fill: "#4f321f"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(59.055 243.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M100.434,489.3a2.281,2.281,0,0,1-.871-.183c-13.729-5.916-22.678-13.923-26.587-23.8-3.415-8.62-2.872-18.569,1.57-28.781,9.965-22.914,5.716-36.455-1.586-41.483-5.55-3.824-13.111-2.909-18.381,2.248a2.213,2.213,0,1,1-3.1-3.162c6.808-6.658,16.671-7.782,24-2.732,8.744,6.028,14.165,21.516,3.124,46.9-2.759,6.345-5.265,15.907-1.511,25.382,3.463,8.744,11.61,15.934,24.221,21.365a2.215,2.215,0,0,1-.877,4.248Z",
    transform: "translate(-50.818 -388.259)",
    fill: "#1c1c1c"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(167.443 152.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M73.19,552.574a2.209,2.209,0,0,1-1.366-3.953c17.413-13.622,15-46.13,13.7-63.6-.237-3.2-.43-5.856-.457-7.749-.124-10.406-2.1-21.08-4.006-31.406-3.06-16.515-6.222-33.6-1.947-50.227a53.237,53.237,0,0,1,13.218-23.672,2.215,2.215,0,0,1,3.189,3.076A48.777,48.777,0,0,0,83.4,396.74c-4.028,15.687-1.1,31.54,2.011,48.323,1.947,10.5,3.953,21.36,4.082,32.153.021,1.823.215,4.388.446,7.475,1.355,18.289,3.883,52.341-15.391,67.414A2.2,2.2,0,0,1,73.19,552.574Z",
    transform: "translate(-70.973 -371.291)",
    fill: "#1c1c1c"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M101.316,367.89c-2.221.748-6.147,4.039-8.5,5.743-4.431,3.184-8.615,6.19-12.745,9.755a54.479,54.479,0,0,0-5.469,5.12,2.3,2.3,0,0,0,.269,3.264,54.871,54.871,0,0,0,6.749,4.727,10.887,10.887,0,0,0,7.061,1.554,29.981,29.981,0,0,0,6.744-1.656c8.212-3.189,20.65-15.665,26.592-22.124C122.5,373.741,103.892,367.024,101.316,367.89ZM98.81,388.755c-2.775,1.764-6.324,4.189-9.583,4.635-2.151.3-5.915-2.087-5.9-2.393.043-.973,20.349-16.208,20.349-16.208s10.755.376,10.621.678C114.293,375.467,102.9,386.152,98.81,388.755Z",
    transform: "translate(109.918 -233.96)",
    fill: "#1c1c1c"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    transform: "translate(136.711 46.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M138.2,420.076c-7.507,5.749-14.262,1.726-13.181-.414a2.321,2.321,0,0,1,.946-.812,4.761,4.761,0,0,0,1.845-6.4,1.371,1.371,0,0,0-.479-.527,1.142,1.142,0,0,0-1.221.231c-.629.543-.742,1.221-1.151,1.866a4.231,4.231,0,0,1-2.06,1.42,14.083,14.083,0,0,1-6.738.941c-24.13-10.008-32.954-17.144-32.954-17.144,4.173-12.46,12.315-33.427,9.438-37.977-1.076-1.7-5.577-3.006-7.867-3.114l-15.638,1.21c.188,1.775-1.861,14.9-3.006,28.313-1.043,12.148-1.35,17.569.172,20.026,3.845,6.211,35.595,15.267,45.8,20.311,1.775.8,6.55,4.044,11.637,6.77,1.689.9,6.125.032,8.54-1.35a19.743,19.743,0,0,0,5.819-5.308c.237-.419.371-.893.57-1.334.344-.747.882-1.4,1.2-2.156C140.61,422.921,139.4,419.156,138.2,420.076Z",
    transform: "translate(-65.258 -323.197)",
    fill: "#fcbe9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M65.6,393.282c-.721,7.389,31.384,10.018,31.766,1.522.124-2.861,1.8-32-4.367-38.923,0,0-1.07-4.3-1.339-4.232-7.136,1.866-16.768,9.18-20.575,17.445C68.583,374.53,66.679,382.215,65.6,393.282Z",
    transform: "translate(-63.797 -351.648)",
    fill: "#fff"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(178.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M90.837,374.908c5.448.941,21.962-2.925,23.441-10.406,0,0-.548-24.581-26.506-21.274-16.794,3-14.7,21.909-14.7,21.909C73.391,368.035,86.158,374.1,90.837,374.908Z",
    transform: "translate(-72.99 -342.922)",
    fill: "#005fc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M113.364,355.414c-3.969.462-8.556,2.334-13.509,5.415a14.431,14.431,0,0,1-13.294.925c-3.275-1.4-7.238-3.291-11.358-5.534,6.061,1.285,29.954-2.344,29.3-9.475C104.5,346.745,117.123,354.967,113.364,355.414Z",
    transform: "translate(-63.3 -326.187)",
    fill: "#2789e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M81.744,344.526c0,.7-1.232,1.28-2.753,1.28s-2.759-.575-2.759-1.28,1.237-1.28,2.759-1.28S81.744,343.821,81.744,344.526Z",
    transform: "translate(-58.8 -341.504)",
    fill: "#2789e1"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M173.3,371.224,82.311,367.8a3.47,3.47,0,0,0-3.668,3.4,3.531,3.531,0,0,0,3.4,3.662l86.908,3.27S174.822,371.294,173.3,371.224Z",
    transform: "translate(130.037 -234.052)",
    fill: "#1c1c1c"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M87.952,378.861c2.038.877,7.679.817,8.766.7,1.839-.188,4.748-.952,4.458-5.582l-2.21-.177c-.828-2.135-1.979-4.641-2.554-5.055a2.561,2.561,0,0,0-2.716-.091,5.173,5.173,0,0,1-1.522.758c-.86.129-1.807-.586-2.673-.667a3.944,3.944,0,0,0-2.678.753c-.28.2-.376.215-.731-.07-1.258-1.006-2.845-.559-2.979,1.07a8.189,8.189,0,0,0,.656,3.463A8.369,8.369,0,0,0,87.952,378.861Z",
    transform: "translate(149.541 -231.756)",
    fill: "#fcbe9f"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M95.9,371.1l18.745-3.308,1.058,10.5-20.145-2.232Z",
    transform: "translate(204.117 -234.05)",
    fill: "#1c1c1c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(258.639 232.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M207.443,371.346,89.61,407.529v5.577L212.274,374.98Z",
    transform: "translate(-80.582 -334.773)",
    fill: "#75ae8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M89.7,369.513l.636-.494-1.46-1.276-.635.494-.312.7.451,145.507,1.463,1.276-.452-145.507Z",
    transform: "translate(-87.931 -350.543)",
    fill: "#4b7759"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M219.37,400.184l-1.463-1.274c-3.329-1.7-66.543-33.955-68.624-34.213-2.565-.495-4.921.306-8.416,1.156-1.871.532-17.09,5.162-30.658,9.3-2.554.774-5.017,1.527-7.351,2.242-.844.253-1.651.5-2.447.742-6.12,1.871-10.793,3.3-11.788,3.6l-.635.495,1.463,1.275.635-.495c3.4-1.043,48.915-14.945,52.244-15.891,3.5-.85,5.856-1.645,8.416-1.156,1.3.167,26.48,12.82,46,22.71,11.712,5.932,21.382,10.863,22.629,11.5Z",
    transform: "translate(-87.678 -364.545)",
    fill: "#a6e8be"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M218.434,399.144c13.121,7.545,8.884,51.276,3.2,69.775-1.608,5.222-5.566,11.32-10.9,16.638a48,48,0,0,1-6.733,5.749,34.7,34.7,0,0,1-10.121,5.362L89.053,528.859l-.4-.177L88.2,383.173l.312-.7.635-.495c3.4-1.043,48.915-14.945,52.244-15.891,3.5-.849,5.856-1.645,8.416-1.156C151.89,365.19,215.1,397.445,218.434,399.144Zm-121.2,39.768,117.83-36.181c-1.882-.963-37.649-19.236-64.085-31.475-3.92-1.124-5.894-.29-11.885,1.474l-42.817,12.7.957,53.486Z",
    transform: "translate(-86.741 -363.505)",
    fill: "#8dcaa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M88.261,402.286l.14,45.387.4.177L193.631,415.66a34.7,34.7,0,0,0,10.121-5.362,48.013,48.013,0,0,0,6.733-5.749c5.329-5.318,9.287-11.417,10.9-16.639.452-1.463.823-3.006,1.183-4.625C164.14,398.861,88.261,402.286,88.261,402.286Z",
    transform: "translate(-86.487 -282.498)",
    fill: "#699f7e",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M113.392,387.271,94.14,393.079c-1.694.575-3.081.21-3.108-.8l-.1-4.033c-.022-1.011,1.328-2.3,3.022-2.872l19.252-5.8c1.689-.575,3.081-.215,3.108.8l.1,4.033C116.435,385.416,115.08,386.7,113.392,387.271Z",
    transform: "translate(-74.808 -299.969)",
    fill: "#649f78"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M90.661,434.058l117.83-36.181c-1.882-.963-37.649-19.236-64.085-31.475-3.92-1.124-5.894-.29-11.885,1.474L89.7,380.572l.957,53.486Z",
    transform: "translate(-80.17 -358.652)",
    fill: "#fffcee",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M117.91,378.714l-25.99,7.808a1.835,1.835,0,0,0-1.344,1.554l.011,2.544c.005.635.608.973,1.35.753l26-7.814a1.83,1.83,0,0,0,1.344-1.549l-.016-2.544C119.259,378.832,118.652,378.493,117.91,378.714Z",
    transform: "translate(-76.358 -302.812)",
    fill: "#efe7da"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutpic);
export default __webpack_public_path__ + "static/media/aboutpic.2aa545045220de8653658adebc053eee.svg";
export { ForwardRef as ReactComponent };